export default {
    greeting: 'Hello',
    submit: 'Submit',
    settings: {
        title: 'Settings',
        schedules: 'Schedules',
        merchantSchedules: 'Merchant Schedules',
        roadSchedules: 'Road Schedules',
        schedulePlanning: 'Schedule planning',
        scheduleLogs: 'Schedule Logs',
        drivers: 'List of drivers',
        driverLocationsHistory: 'History of drivers movements',
        driverIncidents: 'Driver Incidents',
        parameters: 'Parameters',
        deliveryServiceSettings: 'Delivery Service Settings',
        autoDispatchSettings: 'Auto Dispatch Settings',
        printNode: 'PrintNode printers',
        promoCodes: 'Promo Codes',
        users: 'Users',
        zones: 'Zones',
        deliveryZones: 'Delivery zones (destinations)',
        externalShipments: 'External Shipments',
        myAccount: 'My Account',
        integrations: 'E-commerce integrations',
        changePassword: 'Modify password',
        logout: 'Log out',
        printnode: {
            title: 'PrintNode printers',
            setup: 'Remote into the merchant computer, install the PrintNode client, and sign in to the GoLivro PrintNode account. Refresh this page, link the printer to the merchant, then send a test page.',
            download: 'Download the PrintNode client',
            refresh: 'Refresh',
            notConfigured: 'The PrintNode API key is not configured on the server.',
            syncError: 'Could not reach PrintNode. Showing the last known state.',
            account: 'Account',
            credits: 'Credits',
            computers: 'Computers',
            prints: 'Prints',
            connected: 'Connected',
            disconnected: 'Disconnected',
            hostname: 'Computer',
            version: 'Version',
            lastUpdate: 'Last update',
            printer: 'Printer',
            merchant: 'Merchant',
            unassigned: 'Unassigned',
            enabled: 'Auto-print',
            testPrint: 'Test page',
            noComputers: 'No PrintNode computer has connected yet.',
            jobs: 'Recent print jobs',
            order: 'Order',
            test: 'Test',
            state: 'State',
            error: 'Error',
            emptyJobs: 'No print jobs yet.',
            forbidden: 'This page is limited to dispatch and admin users.',
            loading: 'Loading…',
            saved: 'Saved',
            testSent: 'Test page sent.',
        },
    },
    volumeEstimate: {
        title: 'Volume estimate',
        subtitle: 'Starting prices for a small package, one piece per destination.',
        origin: 'Pickup address',
        originPlaceholder: 'Merchant address (optional if a merchant is selected)',
        hubPackages: 'Obibox packages / day',
        flexPackages: 'Flexible packages / day',
        localPackages: 'Local packages / day',
        quebecOntarioPackages: 'Quebec / Ontario packages / day',
        nationwidePackages: 'Nationwide packages / day',
        visitsPerDay: 'Pickup visits / day',
        workingDays: 'Working days / week',
        avgObibox: 'Average Obibox last mile ($)',
        avgFlexKm: 'Average flexible distance (km)',
        avgLar: 'Average LAR quote ($)',
        targetMargin: 'Target margin (%)',
        larMarkup: 'LAR margin (%)',
        firstMileFloor: 'First-mile floor ($)',
        flexDiscountMode: 'Flexible discount',
        modeStopCredit: 'Shared-stop credit',
        modePlannedRate: 'Planned rate',
        postalCodes: 'Sample postal codes (optional)',
        useHistory: 'Use this merchant’s recent destinations',
        calculate: 'Calculate',
        error: 'Could not compute the estimate.',
        startingFrom: 'Starting from',
        startingFromCaption: 'Unit prices (small package, 1 per destination)',
        localTitle: 'Local deliveries',
        localHint: 'Internal flexible service',
        quebecOntarioTitle: 'Quebec / Ontario',
        quebecOntarioHint: 'First mile + Obibox',
        nationwideTitle: 'Nationwide',
        nationwideHint: 'Livraison à rabais resale. Volume does not reduce this price; only the LAR margin does.',
        recommendedFees: 'Recommended rates (copy into the fee card)',
        firstMileFee: 'First mile',
        flexUnitPrice: 'Flexible unit price',
        copyFees: 'Copy rates',
        copied: 'Copied',
        breakEven: 'Floor volume (packages / visit)',
        detailsTitle: 'Cost details',
        column: 'Scenario',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        alaCarte: 'À la carte',
        opsCost: 'Our cost',
        recommended: 'Recommended price',
        halfVolume: 'If volume is 50%',
        volumeBands: 'First mile by packages per pickup',
        packagesPerVisit: 'Packages / visit',
        weeklyAlaCarte: 'Weekly à la carte',
        weeklyRecommended: 'Weekly recommended',
        warnings: {
            hub_km_unavailable: 'Merchant → hub distance unavailable; using the base first-mile fee.',
            merchant_history_empty: 'No recent destinations found for this merchant.',
            obibox_sample_failed: 'Sample Obibox quotes did not succeed.',
            flex_sample_failed: 'Sample flexible quotes did not succeed.',
            obibox_last_mile_missing: 'Enter an average Obibox last mile or postal codes.',
            flex_last_mile_missing: 'Enter an average flexible distance or postal codes.',
            lar_not_configured: 'Livraison à rabais is not configured.',
            lar_origin_postal_missing: 'Origin postal code is required to quote nationwide.',
            lar_sample_failed: 'Livraison à rabais sample quotes did not succeed.',
        },
    },
    changeLanguage: 'Change language',
    orderLegs: {
        sectionTitle: 'Deliveries',
        addLegTitle: 'Add leg',
        cancelForm: 'Cancel',
        legType: 'Leg type',
        typeDelivery: 'Internal delivery',
        typeExternal: 'Third-party shipment',
        deliveryHint: 'Creates a new delivery between the pickup and destination addresses below.',
        externalHint: 'Quotes and creates a carrier shipment between the pickup and destination addresses below.',
        pickupTitle: 'Pickup',
        destinationTitle: 'Destination',
        fieldName: 'Name',
        fieldPhone: 'Phone',
        fieldStreet: 'Street',
        fieldCity: 'City',
        fieldPostalCode: 'Postal code',
        fieldLatitude: 'Latitude',
        fieldLongitude: 'Longitude',
        pickupAddressRequired: 'Please complete the pickup address (street, city, postal code).',
        destinationAddressRequired: 'Please complete the destination address (street, city, postal code).',
        addDeliveryCta: 'Add delivery leg',
        addExternalCta: 'Create external shipment',
        getQuotes: 'Get carrier quotes',
        editDimensions: 'Edit dimensions',
        dimensionsIntro: 'Package dimensions are required to quote carriers.',
        dimensionsRequired: 'Please enter all package dimensions.',
        quoteFailed: 'Unable to fetch carrier quotes.',
        selectCarrier: 'Select a carrier.',
        deliveryFailed: 'Unable to add delivery leg.',
        externalFailed: 'Unable to create external shipment.',
        externalTag: 'Carrier',
        colSequence: 'Sequence',
        colDestination: 'Destination',
        colStatus: 'Status',
        colDriver: 'Driver',
        colRoute: 'Route',
        colDriverPay: 'Driver $',
        colDate: 'Date',
        colDelay: 'Window',
        colAssigned: 'Assigned',
        colArrived: 'Arrived',
        colRecovered: 'Picked up',
        colEnRoute: 'En route',
        colCompleted: 'Completed',
        deliveryDetail: 'Delivery {seq}',
        colPod: 'POD',
        viewPod: 'View POD',
        colActions: 'Actions',
        reunitePickupDelivery: 'Reunite pickup/delivery',
        editLeg: 'Edit',
        colTimeline: 'Steps',
        viewTimeline: 'Timeline',
        timelinePickup: 'Pickup',
        timelineDeliverBefore: 'Deliver before',
    },
    merchantExternalShipment: {
        modifyShipment: 'Edit shipment',
        useEditShipmentAction: 'Third-party carrier orders are always Already Paid. Use Edit shipment to change addresses or delivery comments.',
        thirdPartyNoModifyHint: 'Third-party carrier orders are always Already Paid and cannot be modified here. Contact support if you need help.',
        editBlockedTitle: 'Shipment cannot be edited',
        editBlockedPickedUp: 'Pickup has already occurred — the label can no longer be changed.',
        editBlockedDelivered: 'This order has already been delivered.',
        editBlockedCanceled: 'This shipment has been canceled.',
        editBlockedUnsupportedCarrier: 'This carrier does not support online edits at this time.',
        editBlockedGeneric: 'This shipment can no longer be edited online. Contact support if you need help.',
    },
    externalShipments: {
        orderId: 'Order',
        merchant: 'Merchant',
        destination: 'Destination',
        carrier: 'Carrier',
        service: 'Service',
        dimensions: 'Requested dimensions',
        packages: 'packages',
        tracking: 'Tracking',
        status: 'Status',
        lastUpdate: 'Last update',
        createdAt: 'Created at',
        colRevenue: 'Revenue',
        colCost: 'Carrier cost',
        costTotal: 'Total',
        description: 'List of shipments handled by third-party carriers',
        refresh: 'Refresh',
        empty: 'No third-party shipments at this time.',
        noLabel: 'Label not available.',
        labelError: 'Unable to print label: ',
        cancelConfirm: 'Cancel this third-party shipment?',
        cancelSuccess: 'Shipment cancelled.',
        cancelError: 'Cancellation failed: ',
        pickupSuccess: 'Pickup scheduled: the request will be processed in about 2 minutes.',
        pickupError: 'Pickup request failed: ',
        cancelPickupConfirm:
            'Cancel the scheduled portal pickup? The carrier portal will be updated in about 2 minutes.',
        cancelPickupSuccess: 'Pickup cancel queued: the request will be processed in about 2 minutes.',
        cancelPickupError: 'Could not cancel pickup: ',
        pickupModalTitle: 'Schedule pickup (LAR)',
        pickupModalHint:
            'One-hour slots between 8:00 and 17:00; the “no later than” time must be at least 4 hours after the start.',
        pickupModalHintDateOnly:
            'This carrier only requires a pickup date on the Livraison à rabais portal (no time window).',
        pickupWeekdaysOnlyHint:
            'Weekday pickups only (Mon–Fri) — third-party carriers usually do not pick up on weekends.',
        pickupWeekdayOnlyError: 'Choose a business day (Monday through Friday).',
        pickupDate: 'Pickup date',
        pickupStart: 'From',
        pickupEnd: 'No later than',
        pickupTracking: 'Tracking:',
        pickupConfirm: 'Confirm',
        pickupScheduleWindow: 'Pickup window',
        pickupEndAfterStart: 'End time must be at least 4 hours after start time (between 8:00 and 17:00).',
        pageLabel: 'Page',
        pageOf: 'of',
        totalLabel: 'total',
        statusCreated: 'Created',
        statusPendingPickup: 'Pending pickup',
        statusPickupPlanned: 'Pickup planned',
        statusInSystem: 'In system',
        statusInTransit: 'In transit',
        statusPickedUp: 'Picked up',
        statusAtWarehouse: 'At warehouse',
        statusOutForDelivery: 'Out for delivery',
        statusDelivered: 'Delivered',
        statusDeliveryFailed: 'Delivery failed',
        statusAttention: 'ATTENTION',
        statusCanceled: 'Canceled',
        statusUnknown: 'Unknown',
        trackingModalTitle: 'Tracking information',
        trackingUnavailable: 'Tracking unavailable.',
        trackingError: 'Unable to load tracking: ',
        trackingSummaryTitle: 'Summary',
        trackingSummaryOrder: 'Order',
        trackingSummaryCarrier: 'Integration',
        trackingSummaryStatus: 'Status (GoLivro)',
        trackingSummaryNumbers: 'Tracking numbers',
        trackingSummaryLastUpdate: 'Last update',
        trackingSectionObibox: 'Carrier status (Obibox)',
        trackingSectionIshipOrder: 'iShip tracking (order)',
        trackingSectionIshipByTracking: 'Tracking by number',
        trackingSectionLar: 'Livraison à Rabais order',
        trackingSectionMachool: 'Carrier status (Machool)',
        trackingMachoolProvider: 'Carrier',
        trackingMachoolExpected: 'Expected delivery',
        trackingMachoolDelivered: 'Delivered',
        trackingColStatus: 'Status',
        trackingColDate: 'Date',
        trackingColLocation: 'Location',
        trackingColDescription: 'Description',
        trackingColNumber: 'Number',
        trackingOpenLink: 'Open carrier tracking',
        trackingLarDetailStatus: 'Carrier status',
        trackingLarTracking: 'Tracking',
        trackingRawJson: 'Raw data (JSON)',
        trackingNoDetails: 'No additional details.',
        trackingErrorProvider: 'Error',
        trackingSyncOrderCta: 'Update order',
        trackingSyncOrderSuccess: 'Carrier status synced and order updated.',
        trackingSyncOrderPreserved:
            'Pickup planned preserved: carrier status did not overwrite the local status.',
        trackingSyncOrderError: 'Unable to sync status: ',
        bulkSyncStatus: 'Sync status',
        bulkSyncStatusHint: 'Sync carrier status for the selected shipments',
        exportCsv: 'Export',
        exportCsvHint: 'Export the selection, or every shipment matching the current filters, as CSV',
        exportCsvEmpty: 'No shipments to export.',
        exportCsvError: 'Unable to export: ',
        bulkSyncStatusSuccess: '{count} shipment status synced.',
        bulkSyncStatusSuccessWithPreserved: '{synced} synced, {preserved} kept as pickup planned.',
        bulkSyncStatusPartial: '{ok} synced, {failed} failed.',
        bulkSyncStatusAllFailed: 'Unable to sync the selected shipments.',
        editModalTitle: 'Edit shipment',
        editModalHint:
            'This action cancels the current shipment, then recreates a new shipment with the updated information.',
        editPackageCountDecrease: 'Decrease package count',
        editPackageCountIncrease: 'Increase package count',
        editPackageCountHint:
            'Added packages copy the last package size. A lower count removes packages from the end. The shipment is re-quoted.',
        editPickupSection: 'Pickup',
        editPickupName: 'Name',
        editPickupStreet: 'Address',
        editPickupCity: 'City',
        editPickupPostalCode: 'Postal code',
        editPickupPhone: 'Phone',
        editDeliverySection: 'Delivery',
        editDeliveryName: 'Name',
        editDeliveryStreet: 'Address',
        editDeliveryCity: 'City',
        editDeliveryPostalCode: 'Postal code',
        editDeliveryPhone: 'Phone',
        editDeliveryEmail: 'Email',
        editCommentsLabel: 'Delivery comments',
        editConfirm: 'Confirm updating shipment details and recreating the shipment?',
        editConfirmCta: 'Update and recreate',
        editSuccess: 'Shipment details updated. Shipment has been recreated.',
        editError: 'Unable to update shipment: ',
        editTrackingPrefix: 'New tracking: ',
        duplicateConfirm: 'Duplicate this external shipment as a new order with the same details and pickup window on the next available pickup date?',
        duplicateSuccess: 'External shipment duplicated.',
        duplicateError: 'Unable to duplicate shipment: ',
        changeCarrierModalTitle: 'Change carrier',
        changeCarrierModalHint:
            'This cancels the current shipment and recreates it with the selected carrier. All available options are shown (not only Economy / Express).',
        changeCarrierCurrent: 'Current carrier:',
        changeCarrierCurrentTag: 'Current',
        changeCarrierColCarrier: 'Carrier',
        changeCarrierColService: 'Service',
        changeCarrierColTransit: 'Transit',
        changeCarrierColPrice: 'Cost',
        changeCarrierDays: 'd',
        changeCarrierLoading: 'Loading quotes…',
        changeCarrierNoQuotes: 'No carrier quotes available.',
        changeCarrierQuoteError: 'Unable to load quotes: ',
        changeCarrierConfirm:
            'Confirm carrier change? The current shipment will be canceled and recreated.',
        changeCarrierProceedWithoutCancel: 'Proceed without canceling the first shipment',
        changeCarrierProceedWithoutCancelHint:
            'The current shipment is still canceled when the carrier allows it. If that cancellation fails, the new shipment is created anyway and the original one may stay active with the carrier.',
        changeCarrierConfirmSkipCancel:
            'Confirm carrier change? If canceling the current shipment fails, the new shipment will still be created.',
        changeCarrierConfirmCta: 'Change carrier',
        changeCarrierMachoolTag: 'Machool',
        changeCarrierSuccess: 'Carrier changed. Shipment has been recreated.',
        changeCarrierSuccessPreviousNotCanceled:
            'Carrier changed. The original shipment was not canceled with the carrier.',
        changeCarrierError: 'Unable to change carrier: ',
        priceTesterOpen: 'Price tester',
        priceTesterTitle: 'Third-party price tester',
        priceTesterHint:
            'All LAR, Obibox, and Machool options, without Economy / Express aggregation. Margins and first mile update live.',
        priceTesterPickup: 'Pickup address',
        priceTesterDestination: 'Destination address',
        priceTesterPickupPostalRequired: 'Choose a pickup address with a postal code.',
        priceTesterDestPostalRequired: 'Choose a destination address with a postal code.',
        priceTesterSubmit: 'Get rates',
        priceTesterLoading: 'Loading rates…',
        priceTesterQuoteError: 'Unable to get rates: ',
        priceTesterLiveFields: 'Live configuration',
        priceTesterFirstMile: 'First mile ($)',
        priceTesterFirstMileHintExtra:
            '{{base}} + {{extraKm}} km × {{kmFee}} ({{hubKm}} km to hub, {{includedKm}} km included)',
        priceTesterFirstMileHintIncluded:
            '{{base}} ({{hubKm}} km to hub, {{includedKm}} km included)',
        priceTesterFirstMileHintUnavailable:
            '{{base}} — hub distance unavailable, extra km not added',
        priceTesterLarMargin: 'LAR margin (%)',
        priceTesterObiboxMargin: 'Obibox margin (%)',
        priceTesterMachoolMargin: 'Machool margin (%)',
        priceTesterLarTitle: 'Livraison à Rabais',
        priceTesterObiboxTitle: 'Obibox',
        priceTesterMachoolTitle: 'Machool',
        priceTesterNoLar: 'No LAR options for this request.',
        priceTesterNoObibox: 'No Obibox options for this request.',
        priceTesterNoMachool: 'No Machool options for this request.',
        priceTesterColCarrier: 'Carrier',
        priceTesterColService: 'Service',
        priceTesterColTransit: 'Transit',
        priceTesterColPickup: 'Pickup',
        priceTesterColBase: 'Carrier cost',
        priceTesterColFirstMile: 'First mile',
        priceTesterColMargin: 'Margin',
        priceTesterColSell: 'Customer price',
        priceTesterColEta: 'ETA',
        priceTesterColObiboxCost: 'Obibox cost',
        priceTesterColWithFirstMile: 'Obibox + first mile',
        priceTesterMerchant: 'Merchant (presets)',
        priceTesterMerchantPlaceholder: 'Search a merchant…',
        priceTesterMerchantHelp:
            'Applies that merchant’s margins, first mile, and package defaults. Also fills the pickup address.',
        priceTesterMerchantClear: 'Clear merchant',
        priceTesterPackageSummary: '{{packages}} packages · {{formats}} format(s) sent to carriers',
        larInvoiceOpen: 'LAR invoice',
        larInvoiceModalTitle: 'Livraison à Rabais invoice reconciliation',
        larInvoiceModalHint:
            'Upload the weekly LAR Excel invoice, or the disputed-écart response file (details_ecarts). For écart files, only “Écart maintenu” rows are kept; the justification (column H) is copied onto the invoice. Rows are matched by tracking number. Price differences are re-invoiced (fee + markup); orders not yet on a merchant invoice are billed at the full corrected price instead of only the difference.',
        larInvoiceFileLabel: 'Excel file',
        larInvoiceChooseFile: 'Choose a file',
        larInvoiceNoFile: 'No file',
        larInvoiceRefLabel: 'Carrier invoice reference (internal)',
        larInvoiceAnalyze: 'Analyze',
        larInvoiceParsing: 'Analyzing…',
        larInvoiceSummaryRows: 'Rows',
        larInvoiceSummaryMatched: 'Matched',
        larInvoiceSummaryExtras: 'With difference',
        larInvoiceSummaryFullOrders: 'Uninvoiced orders (full price)',
        larInvoiceSummaryClientTotal: 'Client total to invoice',
        larInvoiceColEstimated: 'Estimated',
        larInvoiceColBilled: 'Billed',
        larInvoiceColExtra: 'Carrier diff.',
        larInvoiceColClient: 'To invoice',
        larInvoiceColNotes: 'Billing notes',
        larInvoiceColStatus: 'Status',
        larInvoiceStatusUnmatched: 'Not found',
        larInvoiceStatusInvoiced: 'Already invoiced',
        larInvoiceStatusFullOrder: 'Full order',
        larInvoiceFullPriceHint: 'Full price',
        larInvoiceStatusExtra: 'Difference',
        larInvoiceStatusOk: 'OK',
        larInvoiceSelectAll: 'Select all',
        larInvoiceNothingSelected: 'Select rows with billable amounts.',
        larInvoiceSelectedTotal: '{{count}} row(s) — {{total}}',
        larInvoiceSubmit: 'Create invoices',
        larInvoiceConfirm: 'Create invoices for {{count}} selected row(s)? Difference rows bill the delta; uninvoiced orders are billed at the full corrected price.',
        larInvoiceSuccess: '{{count}} invoice(s) created: {{links}}',
        obiboxInvoiceOpen: 'Obibox invoice',
        obiboxInvoiceModalTitle: 'Obibox invoice reconciliation',
        obiboxInvoiceModalHint:
            'Upload the Obibox Excel detail file (one row per package). Packages are grouped by order (tracking number or Customer Order hex). Differences are re-invoiced (fee + markup). Orders not yet on a merchant invoice are billed at the full corrected Obibox amount plus first-mile, even when there is no difference.',
        obiboxInvoiceFileLabel: 'Excel file',
        obiboxInvoiceChooseFile: 'Choose a file',
        obiboxInvoiceNoFile: 'No file',
        obiboxInvoiceRefLabel: 'Carrier invoice reference (internal)',
        obiboxInvoiceAnalyze: 'Analyze',
        obiboxInvoiceParsing: 'Analyzing…',
        obiboxInvoiceSummaryRows: 'Orders',
        obiboxInvoiceSummaryPackages: 'Packages',
        obiboxInvoiceSummaryMatched: 'Matched',
        obiboxInvoiceSummaryExtras: 'With difference',
        obiboxInvoiceSummaryFullOrders: 'Uninvoiced orders (full price)',
        obiboxInvoiceSummaryClientTotal: 'Client total to invoice',
        obiboxInvoiceColPackages: 'Pkgs',
        obiboxInvoiceColEstimated: 'Estimated',
        obiboxInvoiceColBilled: 'Actual cost',
        obiboxInvoiceColExtra: 'Carrier diff.',
        obiboxInvoiceColFirstMile: 'First mile',
        obiboxInvoiceColClient: 'To invoice',
        obiboxInvoiceColNotes: 'Billing notes',
        obiboxInvoiceColStatus: 'Status',
        obiboxInvoiceStatusUnmatched: 'Not found',
        obiboxInvoiceStatusInvoiced: 'Already invoiced',
        obiboxInvoiceStatusFullOrder: 'Full order',
        obiboxInvoiceFullPriceHint: 'Full price + first mile',
        obiboxInvoiceStatusExtra: 'Difference',
        obiboxInvoiceStatusOk: 'OK',
        obiboxInvoiceSelectAll: 'Select all',
        obiboxInvoiceNothingSelected: 'Select orders with billable amounts.',
        obiboxInvoiceSelectedTotal: '{{count}} order(s) — {{total}}',
        obiboxInvoiceSubmit: 'Create invoices',
        obiboxInvoiceConfirm: 'Create invoices for {{count}} selected order(s)? Difference rows bill the delta; uninvoiced orders are billed at the full corrected price including first-mile.',
        obiboxInvoiceSuccess: '{{count}} invoice(s) created: {{links}}',
        finalPriceGenerateNow: 'Generate invoices now',
        finalPriceSave: 'Save final prices',
        finalPriceSaveConfirm: 'Save the final carrier price for {{count}} selected row(s)? Uninvoiced orders are picked up by the weekly invoice. Orders already billed (à la carte or the public order form) that have a difference are invoiced immediately.',
        finalPriceAlreadyBilledNow: 'Orders already billed (à la carte or the public order form) with a difference are invoiced immediately, even when this box is unchecked.',
        finalPriceSaved: '{{count}} final price(s) saved.',
        finalPriceNothingSelected: 'Select matched rows.',
        colFinalPrice: 'Final price',
        setFinalPrice: 'Final price',
        setFinalPriceTitle: 'Carrier final price',
        setFinalPriceLabel: 'Amount billed by the carrier (before markup)',
        setFinalPriceInvalid: 'Enter an amount greater than zero, with at most two decimals.',
        setFinalPriceHelp: 'The estimate stays in place. If this order is not on a merchant invoice yet, the customer amount is updated and the weekly invoice will include it.',
        setFinalPriceSaved: 'Final price saved.',
        machoolInvoiceOpen: 'Machool invoice',
        machoolInvoiceModalTitle: 'Machool invoice reconciliation',
        machoolInvoiceModalHint: 'Upload the Machool invoice CSV. Rows match by tracking number, then by ORD- plus the order id in hex. The stored final price is the pre-tax subtotal (combined_sub_total), not the tax-included total. Adjustment rows are added onto the same shipment.',
        machoolInvoiceFileLabel: 'CSV file',
        machoolInvoiceChooseFile: 'Choose a file',
        machoolInvoiceNoFile: 'No file',
        machoolInvoiceRefLabel: 'Carrier invoice reference (internal)',
        machoolInvoiceAnalyze: 'Analyze',
        machoolInvoiceParsing: 'Analyzing…',
        machoolInvoiceSummaryRows: 'Orders',
        machoolInvoiceSummaryPackages: 'Rows',
        machoolInvoiceSummaryMatched: 'Matched',
        machoolInvoiceSummaryExtras: 'With difference',
        machoolInvoiceSummaryFullOrders: 'Uninvoiced orders (full price)',
        machoolInvoiceSummaryClientTotal: 'Client total to invoice',
        machoolInvoiceColPackages: 'Rows',
        machoolInvoiceColEstimated: 'Estimated',
        machoolInvoiceColBilled: 'Actual cost',
        machoolInvoiceColExtra: 'Carrier diff.',
        machoolInvoiceColFirstMile: 'First mile',
        machoolInvoiceColClient: 'To invoice',
        machoolInvoiceColNotes: 'Billing notes',
        machoolInvoiceColStatus: 'Status',
        machoolInvoiceStatusUnmatched: 'Not found',
        machoolInvoiceStatusInvoiced: 'Already invoiced',
        machoolInvoiceStatusFullOrder: 'Full order',
        machoolInvoiceFullPriceHint: 'Full price + first mile',
        machoolInvoiceStatusExtra: 'Difference',
        machoolInvoiceStatusOk: 'OK',
        machoolInvoiceSelectAll: 'Select all',
        machoolInvoiceSelectedTotal: '{{count}} order(s) — {{total}}',
        machoolInvoiceSubmit: 'Create invoices',
        machoolInvoiceConfirm: 'Create invoices for {{count}} selected order(s)? Difference rows bill the delta; uninvoiced orders are billed at the full corrected price including first-mile.',
        machoolInvoiceSuccess: '{{count}} invoice(s) created: {{links}}',
    },
    languageSelect: {
        english: 'English',
        french: 'French',
    },
    deliveries: {
        title: 'Current deliveries',
        newDelivery: 'New Delivery',
        assignDelivery: 'Assign Delivery',
        addOrder: 'Add Order',
        generateRecurringOrders: 'Generate Orders',
        recurringOrders: 'Recurring Orders',
        deliverBefore: 'Deliver Before',
        created: 'Created',
        assigned: 'Assigned',
        arrived: 'Arrived',
        onTheWay: 'On The Way',
        completed: 'Completed',
        cancelled: 'Cancelled',
        returned: 'Returned',
        assign: 'Assign',
        createRoute: 'Create Route',
        addToRoute: 'Add to Route',
        modifyOriginAddress: 'Modify Origin Address',
        modifyDeadline: 'Modify Deadline',
        notifications: 'Notifications',
        filters: 'Filters',
        unassigned: 'Unassigned',
        noDriver: 'No driver',
        urgentDelivery: 'Urgent Delivery',
        fourHourDelivery: '4 Hour Delivery',
        flexibleBusiness: 'Flexible Business',
        flexiblePM: 'Flexible avant 21',
        flexibleWindow: 'Flexible (multi-day)',
        flexibleBefore: 'Flexible — before {{date}}',
        lateOrders: 'Late Orders (ETA)',
        onlineDrivers: 'Online Drivers',
        pickup: 'Pickup',
        destination: 'Destination',
        splitOmitsDestination: 'Destination omitted. Pickup and delivery are split: this stop is only the pickup.',
        splitOmitsPickup: 'Pickup omitted. Pickup and delivery are split: this stop is only the delivery.',
        splitTransitHub: 'Transit address. This destination is a hub drop-off before a third-party carrier shipment.',
        splitTwoLegs: 'This order has more than one delivery leg. This stop covers only one of them.',
        samePickup: {
            badgeLabel: '{{driver}} already heading there',
            badgeLabelMany: '{{count}} drivers already heading there',
            banner: '{{driver}} is already heading to this address and has not been there yet. Avoid sending a second driver unless the parcels do not fit in one vehicle.',
            bannerMany: '{{drivers}} are already heading to this address and have not been there yet. Avoid sending another driver unless the parcels do not fit in one vehicle.',
            driverTag: 'Already heading to this address',
        },
        callTime: 'Call Time',
        deadline: 'Deadline',
        fees: 'Fees',
        driver: 'Driver',
        recurringOrdersGeneratedSuccess: 'Recurring orders generated successfully!',
        noRecurringOrdersGenerated: 'No recurring orders to generate.',
        confirmDeleteRecurringOrder: 'Are you sure you want to delete this recurring order?',
        recurringOrderDeletedSuccess: 'Recurring order deleted successfully.',
        errorDeletingRecurringOrder: 'Error deleting recurring order.',
        errorOccurredDeletingRecurringOrder: 'An error occurred while deleting the recurring order.',
        recurringDeliveriesDescription: 'Manage your recurring delivery schedule. Add deliveries that repeat weekly. Orders are generated automatically every week.',
        addRecurringOrder: 'Add recurring order',
        modifyRecurringOrder: 'Modify recurring order',
    },
    drivers: {
        title: 'Drivers',
        incidents: 'Driver Incidents',
        locationHistory: 'Drivers Location History',
        headers: {
            name: 'Name',
            lastname: 'Last name',
            email: 'Email',
            phoneNumber: 'Phone number',
            password: 'Password'
        },
        actions: {
            modifyTheDriver: 'Modify the driver',
            newDriver: 'New driver',
            modifyPasswordFor: 'Modify password for'
        },
        app: {
            title: 'Mobile app',
            intro: 'Drivers use the GoLivro Driver app.',
            android: 'Android',
            ios: 'iOS',
            sendTitle: 'Send a link by email',
            platform: 'Platform',
            send: 'Send',
            sent: 'The link was sent.',
            sendFailed: 'Could not send the link. Please try again.',
        }
    },
    driversLocationsHistory: {
        mapTitle: 'Positions of drivers over time',
        searchDriver: 'Search for a driver...',
        selectDateTimeForLocations: 'Select a date and time range to view the locations of drivers. Use the slider to browse the timeline.',
        selectDatesSlider: 'Select dates and move the slider',
        selectDriver: 'Select a driver',
        loadingMap: 'Loading map...'
    },
    merchants: {
        title: 'Merchants',
        registration: {
            title: 'Merchant Registration',
            account: 'Account',
            profile: 'Profile',
            confirmation: 'Confirmation',
            success: 'Registration successful!',
            termsBeforeLink: 'By continuing, I accept the ',
            termsLinkText: 'Terms of Use',
            termsAfterLink: '.',
            signInPrompt: 'Already have an account? Sign in'
        },
        form: {
            generalInfo: {
                name: 'Name',
                businessName: 'Business Name',
                billingEmail: 'Billing Email',
                multipleEmailsNote: 'If multiple, separate with commas',
                phone: 'Phone Number',
                address: 'Address',
                pickupComment: 'Pickup Comment',
                pickupCommentPlaceholder: 'Special instructions for pickup',
                contactPerson: 'Contact person name',
                contactPhone: 'Contact person phone number',
                contactEmail: 'Contact person email',
                merchantType: 'Merchant Type',
                merchantTypePlaceholder: 'Merchant Type',
                ueatDeliveryFee: 'UEAT: customer delivery fee',
                ueatOptions: {
                    disable: 'Disable',
                    fixedFee: '$ fixed fee',
                    percentage: '% percentage'
                }
            },
            settings: {
                useSMS: 'Use SMS',
                usePOD: 'Use delivery proof',
                useSignature: 'Use signature',
                usePOS: 'Use payment service',
                hasDrivers: 'Use own drivers',
                useDeliveryZones: 'Use delivery zones',
                notifEmailConsignee: 'Status update emails to recipient',
                notifEmailSender: 'Status update emails to sender'
            },
            sections: {
                contact: 'Contact and pickup address',
                delivery: 'Delivery options',
                notifications: 'Email notifications',
                square: 'Square',
            },
            square: {
                connect: 'Connect Square',
                disconnect: 'Disconnect Square',
                connected: 'Square account connected',
                disconnected: 'No Square account connected',
                connectSuccess: 'Your Square store is now connected.',
                connectError: 'Square connection failed. Please try again.',
                connectDenied: 'Square connection was denied.',
                disconnectConfirm: 'Disconnect your Square account? New online orders will no longer be imported.',
            },
            invoicing: {
                billingCycle: 'Billing Cycle',
                billingCyclePlaceholder: 'Billing Cycle',
                serviceFees: 'Service Fees',
                informatique: 'IT service merchant',
                weekly: 'WEEKLY',
                biweekly: '2 WEEKS',
                monthly: 'MONTHLY',
                usageBased: 'Usage-based (À la carte)'
            }
        },
        validation: {
            nameRequired: 'Please enter a name',
            emailRequired: 'Please enter an email',
            passwordRequired: 'Please enter a password',
            passwordMinLength: 'Password must contain at least 8 characters',
            passwordConfirmationRequired: 'Please confirm the password',
            passwordsDoNotMatch: 'Passwords do not match',
            merchantTypeRequired: 'Please specify the merchant type',
            addressRequired: 'Please choose an address from the dropdown list',
            phoneRequired: 'Please enter a phone number',
            contactNameRequired: 'Please enter the contact name',
            contactPhoneRequired: 'Please enter the contact person\'s phone number',
            termsRequired: 'You must accept the Terms of Use to continue'
        },
        merchantCategoryLabels: {
            1: 'Restaurant',
            2: 'Florist',
            3: 'Courier',
            4: 'Pharmacy',
            5: 'Other',
            6: 'Pet store',
            7: 'Grocery store',
            8: 'Convenience store',
            9: 'Bakery & pastry shop'
        }
    },
    users: {
        title: 'Users Management',
        name: 'Name',
        email: 'Email',
        role: 'Role',
        actions: {
            modifyUser: 'Modify user',
            newUser: 'New user'
        }
    },
    routes: {
        title: 'Current Routes',
        history: 'Route History',
        confirmRemoveRoute: 'Are you sure you want to remove this route? Orders will be returned to the unassigned orders list.',
        confirmAcceptRoute: 'Are you sure you want to generate this route?',
        confirmAcceptAllRoutes: 'Are you sure you want to generate {count} route(s)?',
        acceptingRoutes: 'Accepting...',
        acceptRoute: 'Accept route',
        removeRoute: 'Remove route',
        acceptRoutes: 'Accept routes',
        shiftSuggestions: {
            refresh: 'Driver suggestions',
            countLabel: 'suggestion(s)',
            estimatedDuration: '~{minutes} min estimated',
            someUncovered: 'Some drivers have no shift covering this route',
            error: 'Could not load driver suggestions.',
        },
        headers: {
            itinerary: 'Route',
            completedStops: 'Completed Stops',
            distance: 'Distance',
            duration: 'Duration',
            driver: 'Driver',
            deliveries: 'Deliveries',
            actions: 'Actions',
        },
        groups: {
            unscheduled: 'Unscheduled',
        },
        dragHint: 'Drag a stop onto another driver\'s list to move that delivery (pickup + drop-off). Reorder stops within a list as usual.',
    },
    routeView: {
        route: 'Route',
        steps: 'Steps',
        routeCompleted: 'Route completed:',
        type: 'Type',
        order: 'Order',
        scheduleDeadline: 'Schedule/Deadline',
        eta: 'ETA',
        estimatedTime: 'Estimated time',
        actualTime: 'Actual time',
        driverPayment: 'Driver payment ($)',
        delivery: 'Delivery',
        headers: {
            driver: 'Driver',
            distance: 'Distance',
            address: 'Address',
        },
    },
    schedule: {
        roadSchedules: 'Road Schedules',
        merchantSchedule: '5@8 Schedule',
        servicesAttitres: 'Dedicated services',
        logs: 'Schedule Logs',
        title: {
            confirmDriverShift: 'Please confirm the driver\'s working hours'
        },
        actions: {
            addShift: 'Add a shift',
            generateShifts: 'Generate shifts for this period',
            filter: 'Filter',
            today: 'Today',
            byWeek: 'By Week',
            byDay: 'By Day',
            byCalendar: 'Calendar',
            validateHours: 'Validate hours',
            recurringShifts: 'Recurring shifts',
            modify: 'Modify',
            add: 'Add',
            bulkConfirmDriver: 'Confirm shifts',
            bulkUnconfirmDriver: 'Unconfirm shifts',
            bulkUnassignDriver: 'Unassign drivers',
            bulkDeleteShifts: 'Delete shifts',
            selectAll: 'Select all',
        },
        bulkConfirm: {
            confirmSelectedPrompt: 'Confirm attendance for {count} selected shift(s)?',
            successSelected: '{count} shift(s) confirmed.',
            unconfirmSelectedPrompt: 'Unconfirm {count} selected shift(s)?',
            successUnconfirmed: '{count} shift(s) unconfirmed.',
            unassignSelectedPrompt: 'Unassign the driver from {count} selected shift(s)?',
            successUnassigned: '{count} shift(s) unassigned.',
            deleteSelectedPrompt: 'Delete {count} selected shift(s)?',
            successDeleted: '{count} shift(s) deleted.',
        },
        stats: {
            terrain: 'Terrain',
            serviceAttitre: 'Dedicated Service',
            guaranteed: 'guaranteed revenue',
            uniqueDrivers: 'Unique drivers',
        },
        filters: {
            withWho: 'With who',
            terrain: 'Terrain',
            serviceAttitre: 'Dedicated Service',
            allShifts: 'All shifts',
            freeShifts: 'Free shifts',
            guaranteedShifts: 'Guaranteed shifts',
            zones: 'Zones'
        },
        suggestions: {
            title: 'Suggestions',
            generate: 'Generate suggestions',
            applyAll: 'Apply all suggestions',
            removeAll: 'Remove suggestions',
            show: 'Show suggestions',
            hide: 'Hide suggestions',
            replaceExistingOnApply: 'Replace current shifts with suggestions',
            confirmApply: 'Are you sure you want to apply all suggestions?',
            confirmApplyReplace: 'Are you sure you want to replace all current shifts with the suggestions?',
            confirmApplyDay: 'Are you sure you want to apply suggestions for {day}?',
            confirmApplyDayReplace: 'Are you sure you want to replace current shifts for {day} with the suggestions?',
        },
        messages: {
            noShiftsForDate: 'No shifts for this date.',
            confirmGenerate: 'There are already shifts for this period. Do you still want to generate new shifts?',
            errorOccurred: 'An error occurred, please try again later',
            errorOccurredShort: 'An error occurred',
            confirmDelete: 'Are you sure you want to delete?'
        },
        days: {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday'
        },
        calendar: {
            to: 'to',
            period14: '2 weeks',
            period21: '3 weeks',
            period28: '4 weeks',
            noShifts: '—',
            noRequirement: 'No requirement',
            cellTitle: '{filled}h filled of {total}h ({percent}%)'
        },
        heatmap: {
            title: 'Weekly coverage',
            hour: 'Hour',
            total: 'Total',
            coverageLabel: 'Coverage shown',
            coverageAssigned: 'Assigned',
            coveragePlanned: 'Planned',
            coverageOnRoad: 'On the road',
            coverageFillRate: 'Coverage',
            subtitle: {
                assigned: 'Number of assigned drivers per time slot (shifts with a driver).',
                planned: 'Number of planned shifts per time slot (all shifts).',
                onRoad: 'Number of completed routes per time slot (actual start_time → end_time).',
                coverage: 'Assigned drivers per time slot. Color: assigned / planned (< 70% red, 70–90% yellow, 90%+ green).',
            },
            cellTitle: {
                assigned: '{value} driver(s) assigned',
                planned: '{value} shift(s) planned',
                onRoad: '{value} route(s) on the road',
                coverage: '{assigned}/{planned} driver(s)',
            },
            cellTitleWithPercent: {
                coverage: '{assigned}/{planned} driver(s) ({percent}%)',
            },
            legendGreen: '90%+',
            legendYellow: '70–90%',
            legendRed: '<70%',
        },
        roadScheduleHeatmap: {
            shiftCategoryLabel: 'Shift type shown',
            normalShifts: 'Normal shifts',
            suggestedShifts: 'Suggested shifts',
            subtitle: {
                normal: 'Coverage for normal road schedule shifts (preassigned DEFAULT_DRID / planned). Color: assigned / planned (< 70% red, 70–90% yellow, 90%+ green).',
                suggested: 'Coverage for suggested road schedule shifts (preassigned DEFAULT_DRID / planned). Color: assigned / planned (< 70% red, 70–90% yellow, 90%+ green).',
            },
        },
        merchantScheduleHeatmap: {
            subtitle: 'Coverage for 5@8 merchant schedules (preassigned DEFAULT_DRID / planned). Color: assigned / planned (< 70% red, 70–90% yellow, 90%+ green).',
        },
        headers: {
            driver: 'Driver',
            merchant: 'Merchant',
            dedicatedDrivers: 'Dedicated drivers service',
            city: 'City',
            startAddress: 'Start location',
            schedule: 'Schedule',
            date: 'Date',
            confirmation: 'Confirmation',
            recurrent: 'Recurrent',
            actions: 'Actions'
        },
        status: {
            noDriverAssigned: 'No driver assigned',
            driverConfirmed: '(DRIVER)',
            driverNotConfirmed: 'To confirm',
            merchantApproved: '(MERCHANT)'
        },
        noDriverAssigned: 'No driver assigned',
        noShifts: 'No shifts',
        shiftPublishInfo: 'Publish shifts as needed. Our team members will place drivers at your business who will work with you for the entire shift.',
        glossary: {
            today: 'Today',
            to: 'to',
            aShift: 'a shift'
        },
        shiftToConfirmWarning1: 'Click the \'Validate\' button to approve shift hours.',
        shiftToConfirmWarning2: 'shift(s) to confirm.',
        driverConfigMessage1: 'Recurring shifts are repeated every week.',
        driverConfigMessage2: 'They are generated every:',
        cannotModifyAfterConfirmWarning: 'Once the shift is confirmed, it will no longer be possible to make modifications.',
        driverAvailabilities: {
            title: 'Driver availabilities',
            subtitle: 'Create, edit, or delete driver availability windows (one-off or weekly recurring).',
            addTitle: 'Add availability',
            editTitle: 'Edit availability',
            weekReferenceDate: 'Week (reference date)',
            driver: 'Driver',
            selectDriver: 'Select a driver',
            referenceDate: 'Reference date',
            referenceDateHelp: 'For a recurring weekly slot, this date sets the weekday. Rows shown are for the week that contains this date.',
            recurringWeekly: 'Every week (recurring)',
            dateOrRecurrence: 'Date / weekday',
            start: 'Start',
            end: 'End',
            validationDriver: 'Please select a driver.',
            validationMissing: 'Please fill in the date and times.',
            createdAt: 'Created',
            updatedAt: 'Updated',
        }
    },
    business: {
        title: 'Business Settings',
    },
    menu: {
        title: 'Menu',
        mainMenu: 'Main Menu',
        driverLocationHistory: 'Driver Location History',
        deliveryServiceSettings: 'Delivery Service Settings',
        autoDispatchSettings: 'Auto Dispatch Settings',
        management: 'Management',
        manageMerchants: 'Manage Merchants',
        manageDrivers: 'Manage Drivers',
        manageOrders: 'Manage Orders',
        integration: 'Integration',
        merchantIntegration: 'Merchant Integration',
        driverIntegration: 'Driver Integration',
        emailPreferences: 'Email Preferences',
        shiftConfirmReminderLabel: 'Receive a daily email reminder of unconfirmed shifts',
        shiftConfirmationLabel: 'Receive a confirmation for each added shift',
        driverAssignedToShiftLabel: 'Receive a notification when a driver is assigned to a shift',
        pickupFailedLabel: 'Receive an email when a pickup fails',
        deliveryFailedLabel: 'Receive an email when a delivery fails',
        orderStatusSenderLabel: 'Order status updates',
        defaultLabel: 'Unspecified preference',
        preference: 'Preference',
        integrations: {
            shopify: 'Shopify',
            shopifyDescription: 'Install the On Ship Ça Shopify app to import your online orders.',
            shopifyCta: 'Install the app',
            deliverect: 'Deliverect',
            deliverectDescription: 'Connect Deliverect to import your online orders.',
            deliverectCta: 'View the integration',
            ueat: 'Ueat',
            ueatDescription: 'Contact us to connect your Ueat restaurant.',
            ueatCta: 'Contact us',
        },
    },
    promoCode: {
        title: 'Promo Codes',
    },
    zones: {
        title: 'Zones',
        description: 'Manage your delivery zones',
        addZone: 'Add Zone',
        editZone: 'Edit Zone',
        deleteZone: 'Delete Zone',
        confirmDelete: 'Are you sure you want to delete this zone?',
        name: 'Zone Name',
        zoneDescription: 'Description',
        color: 'Color',
        center: 'Center Point',
        coordinates: 'Zone Coordinates',
        latitude: 'Latitude',
        longitude: 'Longitude',
        addPoint: 'Add Point',
        removePoint: 'Remove Point',
        saveSuccess: 'Zone saved successfully',
        deleteSuccess: 'Zone deleted successfully',
        saveError: 'Failed to save zone',
        deleteError: 'Failed to delete zone',
        loadError: 'Failed to load zones',
        noZones: 'No zones configured',
        drawOnMap: 'Draw on map',
        clearDrawing: 'Clear drawing',
        clickMapToAdd: 'Click on the map to add points. Click on existing markers to remove them.',
        clickToRemove: 'Click to remove point',
        postalCodes: 'Postal codes (FSA, e.g. H1A, J4B)',
        showFsaOnMap: 'Show FSA on map',
        enterPostalCodesToShowFsa: 'Enter at least one postal code (FSA) to show boundaries on the map.',
        fsaBoundariesError: 'Could not load FSA boundaries. Check that the Python service is running.',
    },
    deliveryZones: {
        title: 'Delivery Zones (Destinations)',
        description: 'Define the postal codes (FSA) where you deliver. Default for all merchants, or specific to one merchant. If a delivery address is outside the zone, third-party options (Obibox) are suggested.',
        addZone: 'Add zone',
        editZone: 'Edit zone',
        confirmDelete: 'Are you sure you want to delete this delivery zone?',
        defaultZone: 'Default zone (all merchants)',
        merchantOverride: 'Specific merchant',
        selectMerchant: 'Select a merchant',
        postalCodes: 'Postal codes FSA (e.g. H1A, J4B, J4Y)',
        postalCodesPlaceholder: 'H1A, J4B, J4Y (comma-separated)',
        saveSuccess: 'Delivery zone saved',
        saveError: 'Failed to save',
        deleteError: 'Failed to delete',
        loadError: 'Failed to load',
        noZones: 'No delivery zones configured. Addresses outside the default region (Montreal, Laval, South Shore) will suggest third-party delivery.',
        scope: 'Scope',
        zoneType: 'Zone type',
        requiredPostalCodes: 'Please enter at least one postal code (FSA).',
    },
    localDeliveryZones: {
        title: 'Local zones (hubs)',
        description: 'Geographic zones (e.g. Montreal, Quebec City). Same zone = standard rate; different zones = long_distance_rate.',
        addZone: 'Add local zone',
        editZone: 'Edit zone',
        zoneIdentifier: 'Zone',
        zoneIdentifierHelp: 'E.g. montreal, quebec_city (lowercase, underscores)',
        requiredIdentifier: 'Zone identifier required (e.g. montreal, quebec_city)',
        pickupWeekdays: 'Pickup days',
        pickupWeekdaysHelp: 'Days when local pickup is available (e.g. Mon–Fri for Quebec City).',
        dayMon: 'Mon',
        dayTue: 'Tue',
        dayWed: 'Wed',
        dayThu: 'Thu',
        dayFri: 'Fri',
        daySat: 'Sat',
        daySun: 'Sun',
    },
    invoice: {
        merchantInvoices: 'Merchant Invoices',
        driverReceipts: 'Driver Receipts',
        pleaseSpecifyStartDate: 'Please specify a start date',
        pleaseSpecifyEndDate: 'Please specify an end date',
        pleaseChooseBillingCycle: 'Please choose a billing cycle',
        invoicesAlreadyGenerated: 'Warning! Invoices have already been generated for this period. Do you want to regenerate them?',
        confirmDeleteInvoices: 'Are you sure you want to delete these invoices?',
        confirmRefundOnDelete: 'Some of these invoices have an associated payment. Do you want to refund the payment(s) as well?',
        start: 'Start',
        end: 'End',
        periodFilter: 'Period Filter',
        issueDate: 'Issue Date',
        billingPeriod: 'Billing Period',
        invoiceAmount: 'Invoice Amount',
        positiveInvoices: 'Positive Invoices',
        negativeInvoices: 'Negative Invoices',
        billingCycle: 'Billing Cycle',
        paymentMethod: 'Payment Method',
        paymentTransaction: 'Payment transaction',
        transactionId: 'Transaction ID',
        currency: 'Currency',
        reference: 'Reference',
        banking: 'Banking',
        creditCard: 'Credit Card',
        paidNotPaid: 'Paid/Not Paid',
        activeStatus: 'Invoice status',
        activeInvoices: 'Active',
        canceledInvoices: 'Canceled',
        allInvoices: 'All',
        numberOfInvoices: 'Number of Invoices',
        serviceFees: 'Service Fees',
        taxable: 'Taxable',
        nonTaxable: 'Non Taxable',
        gst: 'GST',
        qst: 'QST',
        net: 'NET',
        invoiceNumber: 'Invoice #',
        viewed: 'Viewed',
        margin: 'Margin ($/%)',
        bankFiles: 'Bank Files',
        chargeCreditCard: 'Charge Credit Card',
        confirmChargeCreditCard: 'Charge the credit card for {{count}} selected invoice(s)?',
        chargeCreditCardHint: 'Charging {{count}} invoice(s) on file payment methods.',
        chargeCreditCardCanClose: 'You can close this window. Credit card charges will continue in the background.',
        chargeCreditCardCompleted: 'Credit card charges completed successfully.',
        chargeCreditCardCompletedWithErrors: 'Completed: {{succeeded}} succeeded, {{failed}} failed.',
        chargeCreditCardFailed: 'Credit card charging failed.',
        chargeCreditCardStatus: {
            queued: 'Queued',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },
        depositReconciliation: 'Credit card deposit reconciliation',
        depositReconciliationHint: 'Export a CSV reconciliation between active credit-card paid invoices and Global Payments deposits for the selected period.',
        depositReconciliationRefundedHint: 'Refunded invoices mode: only canceled invoices (ACTIVE=0) in the period, with their SALE + REFUND transactions.',
        depositReconciliationRefundedOnly: 'Refunded invoices only (canceled)',
        depositReconciliationInvoiceTitle: 'Credit card reconciliation — invoice #{{miid}}',
        depositReconciliationInvoiceHint: 'Reconcile invoice #{{miid}} against Global Payments deposits. An email will be sent when the CSV is ready.',
        depositReconciliationRefundHint: 'Reconcile SALE + REFUND for invoice #{{miid}} against Global Payments deposits (Deposit ID, dates, amounts). An email will be sent when the CSV is ready.',
        confirmDepositReconciliationInvoice: 'Start credit card deposit reconciliation for invoice #{{miid}}?',
        confirmRefundDepositReconciliation: 'Start deposit reconciliation for SALE and REFUND transactions of invoice #{{miid}}?',
        depositReconciliationNotCreditCard: 'This invoice was not paid by credit card.',
        startDepositReconciliation: 'Start reconciliation',
        startDepositReconciliationRefunded: 'Start reconciliation (refunded)',
        refundLookupTitle: 'Credit card refunds — invoice #{{miid}}',
        refundLookupHint: 'Search Global Payments REFUND transactions linked to this canceled invoice payment (TRN_…). Adjust the dates if the refund happened later.',
        refundLookupSearch: 'Search refunds',
        refundLookupReconcileDeposits: 'Deposit reconciliation (SALE + REFUND)',
        refundLookupSale: 'Payment transaction (SALE)',
        refundLookupRefundId: 'Refund ID',
        refundLookupReference: 'Reference',
        refundLookupNoneFound: 'No refunds found between {{from}} and {{to}} for this payment_id.',
        depositReconciliationCanClose: 'You can close this window. An email will be sent to {{email}} when the file is ready.',
        depositReconciliationEmailSent: 'The file is ready. An email with the CSV attachment has been sent.',
        depositReconciliationFailed: 'The reconciliation failed. An error email has been sent.',
        depositReconciliationStatus: {
            queued: 'Queued',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },
        markAsPaid: 'Mark as Paid',
        generateInvoices: 'Generate Invoices',
        generateInvoicesCanClose: 'You can close this window. Invoice generation will continue in the background.',
        generateInvoicesCompleted: 'Invoice generation completed successfully.',
        generateInvoicesCompletedWithErrors: 'Completed: {{succeeded}} succeeded, {{failed}} failed.',
        generateInvoicesFailed: 'Invoice generation failed.',
        generateInvoicesStatus: {
            queued: 'Queued',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },
        ordersWithoutInvoiceOpen: 'Uninvoiced orders & shifts',
        ordersWithoutInvoiceTitle: 'Orders and shifts without invoice',
        ordersWithoutInvoiceHint:
            'Lists billable-merchant orders with no report line and MerchantSchedule shifts with no invoice line in the date range. Select what to invoice (orders-only and/or shift-only invoices; no cycle fees).',
        ordersWithoutInvoiceOrdersHeading: 'Uninvoiced orders',
        ordersWithoutInvoiceFetchType: 'Include',
        ordersWithoutInvoiceFetchBoth: 'Orders and shifts',
        ordersWithoutInvoiceFetchOrders: 'Orders only',
        ordersWithoutInvoiceFetchShifts: 'Shifts only',
        ordersWithoutInvoiceNeedDates: 'Please specify a start and end date.',
        ordersWithoutInvoiceSearch: 'Search',
        ordersWithoutInvoiceSearching: 'Searching…',
        ordersWithoutInvoiceSummaryOrders: 'Orders',
        ordersWithoutInvoiceSummaryMerchants: 'Merchants',
        ordersWithoutInvoiceEmpty: 'No uninvoiced orders for this period.',
        ordersWithoutInvoiceSelectAll: 'Select all',
        ordersWithoutInvoiceColOrid: 'ORID',
        ordersWithoutInvoiceColMerchant: 'Merchant',
        ordersWithoutInvoiceColStatus: 'Status',
        ordersWithoutInvoiceColScheduled: 'Scheduled',
        ordersWithoutInvoiceColDelivered: 'Delivered',
        ordersWithoutInvoiceColCommission: 'Mileage fee',
        ordersWithoutInvoiceColDestination: 'Destination',
        ordersWithoutInvoiceNothingSelected: 'Select orders or shifts to invoice.',
        ordersWithoutInvoiceSelected: '{{orderCount}} order(s), {{shiftCount}} shift(s) selected',
        ordersWithoutInvoiceSubmit: 'Generate invoices',
        ordersWithoutInvoiceConfirm: 'Create invoices for {{orderCount}} selected order(s) and {{shiftCount}} selected shift(s)?',
        ordersWithoutInvoiceSuccess: '{{orderInvoices}} order invoice(s) ({{items}} report line(s)), {{shiftInvoices}} shift invoice(s) ({{shiftItems}} line(s)). MIID: {{miids}}',
        invoiceThisOrder: 'Invoice this order',
        invoiceThisOrderConfirm: 'Generate an invoice for this order?',
        invoiceThisOrderSuccess: 'Invoice #{{miid}} created.',
        invoiceThisOrderFailed: 'Could not generate the invoice.',
        invoiceThisOrderView: 'View invoice #{{miid}}',
        shiftsWithoutInvoiceTitle: 'Uninvoiced shifts',
        shiftsWithoutInvoiceEmpty: 'No uninvoiced schedule shifts for this period.',
        shiftsWithoutInvoiceSummaryShifts: 'Shifts',
        shiftsWithoutInvoiceSummaryAmount: 'Amount',
        shiftsWithoutInvoiceSelectAll: 'Select all shifts',
        shiftsWithoutInvoiceColShiftid: 'SHIFTID',
        shiftsWithoutInvoiceColDate: 'Date',
        shiftsWithoutInvoiceColDriver: 'Driver',
        shiftsWithoutInvoiceColHours: 'Hours',
        shiftsWithoutInvoiceColAmount: 'Amount',
        allMerchants: 'All Merchants',
        payrollAlreadyGenerated: 'Warning! Payroll has already been generated for this period. Do you want to regenerate it?',
        confirmDeleteReports: 'Are you sure you want to delete these reports?',
        numberOfReceived: 'Number of Received',
        tips: 'Tips',
        amountOwed: 'Amount Owed',
        amountToRefund: 'Amount to Refund',
        adminFees: 'Admin Fees',
        gstFees: 'GST Fees',
        taxes: 'Taxes',
        qstFees: 'QST Fees',
        commissions: 'Commissions',
        grandTotal: 'Grand Total',
        additionalDetails: 'Additional Details',
        routesTotal: 'Routes Total',
        driverCommission: 'Driver Commission',
        bonuses: 'Bonuses',
        guarantees: 'Guarantees',
        reportNumber: 'Report #',
        totalTest: 'Total Test',
        fees: 'Fees',
        regenerate: 'Regenerate',
        exportACH: 'Export ACH',
        receipt: 'Receipt',
        generatePayroll: 'Generate Payroll',
        generatePayrollCanClose: 'You can close this window. Payroll generation will continue in the background.',
        generatePayrollCompleted: 'Payroll generation completed successfully.',
        generatePayrollFailed: 'Payroll generation failed.',
        generatePayrollStatus: {
            queued: 'Queued',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
        },
        completeRequiredFields: 'Please fill in all required fields',
        specifyPeriod: 'Please specify the period (start and end dates)',
    },
    billing: {
        paymentProblem: 'Payment problem: ',
        choosePaymentMethod: 'Choose your payment method:',
        payWithSavedCard: 'Pay with saved credit card',
        payWithNewCard: 'Pay with a new credit card',
        confirmPaymentWithSavedCard: 'Confirm payment with your saved card',
        confirmPayment: 'Confirm payment',
        selectedInvoicesCount: 'Number of selected invoices:',
        totalNetAmount: 'Total net amount:',
        total: 'Total',
        notPaid: 'Not paid',
        paid: 'Paid',
        canceled: 'Canceled',
        period: 'Period',
        to: 'to',
        paymentMethod: 'Payment method',
        addPaymentMethod: 'Add a payment method:',
        bankingOption: 'Void cheque / Bank deposit',
        creditOption: 'Credit card',
        registeredPaymentMethod: 'Registered payment method:',
        bankingSpecimen: 'Void cheque',
        creditCard: 'Credit card',
        change: 'Modify',
        changePaymentMethod: 'Change payment method',
        selectPaymentMethod: 'Select a payment method:',
        creditPayment: 'Credit card payment',
        fetchError: 'Failed to retrieve payment method.',
        transitNumber: 'Transit number',
        institutionNumber: 'Institution number',
        accountNumber: 'Account number',
        customerNumber: 'Customer number',
        pleaseIndicateTransit: 'Please indicate your transit number',
        pleaseIndicateInstitution: 'Please indicate your institution number',
        pleaseIndicateAccount: 'Please indicate your account number',
        pleaseIndicateCustomer: 'Please indicate the customer number',
        send: 'Send',
        voidChequeInfo: 'You will find the necessary information on a void cheque, which can be provided by your bank.',
        voidChequeAlt: 'Void cheque',
        cardNumber: 'Card number',
        cardNumberRequired: 'Card number is required.',
        cardNumberInvalid: 'This card number looks invalid.',
        expiration: 'Expiration',
        expirationRequired: 'Expiration date is required.',
        expirationInvalid: 'This expiration date looks invalid.',
        cvv: 'CVV',
        cvvRequired: 'Security code is required.',
        cvvInvalid: 'This security code looks invalid.',
        cardholderName: 'Cardholder name',
        cardholderNameRequired: 'Cardholder name is required.',
        cardholderNameInvalid: 'Cardholder name looks invalid.',
        saveCardForFuture: 'Save card for future payments',
        payNow: 'Pay now',
        save: 'Save'
    },
    reports: {
        orders: 'Orders',
        kpi: 'KPI',
        data: 'Data',
        nbOrders: 'Nb orders',
        numberOfOrders: 'Number of orders',
        totalMerchantCommissions: 'Total merchant commissions',
        totalDriverCommissions: 'Total driver commissions',
        tips: 'Tips',
        nbCancelledOrders: 'Nb cancelled orders',
        guarantees: 'Guarantees',
        nbDriversWithGuarantees: 'Nb drivers with guarantees',
        drivers: 'Drivers',
        nbWorkedHours: 'Nb worked hours',
        nbGuarantees: 'Nb guarantees',
        totalDriverCommissions: 'Total driver commissions',
        bonuses: 'Bonuses',
        nbBonuses: 'Nb bonuses',
        averageDeliveryTime: 'Average delivery time',
        averageDistance: 'Average distance',
        averageInvoice: 'Average invoice',
        percentageDelivery: 'On-time delivery',
        showPaymentMethod: 'Show payment method details',
        paiementMethod: {
            debit: 'Debit',
            credit: 'Credit',
            cash: 'Cash'
        },
        convertion: {
            machineToComptant: 'Machine -> Cash',
            cashToDebit: 'Cash -> Debit',
            cashToCredit: 'Cash -> Credit'
        },
        customDisplay: {
            orderTotal: 'orders, total:'
        },
        date: 'Date',
        deliveredTo: 'Delivered to',
        address: 'Address',
        client: 'Client',
        driver: 'Driver',
        deliveredByGoLivro: '(Delivered by GO LIVRO)',
        noDriver: 'No driver',
        paymentMethod: 'Payment method',
        tip: 'Tip',
        start: 'Start',
        startTime: 'Start (time)',
        end: 'End',
        endTime: 'End (time)',
        deliveryProof: 'Proof of delivery'
    },
    auth: {
        login: 'Login',
        email: 'Email',
        password: 'Password',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot password?',
        createAccount: 'Create account',
        forgotPasswordTitle: 'Forgot password',
        resetPassword: 'Reset password',
        registerDispatch: 'Dispatch company registration',
    },
    validation: {
        required: 'The :attribute field is required.',
        tryLater: 'Please try again later',
        proceedConfirmation: 'Are you sure you want to close this route? Pending deliveries will be marked as completed.',
        deleteDriver: 'Are you sure you want to delete this driver?',
        deleteAddresse: 'Are you sure you want to delete this address?',
        enterDriverName: 'Please enter the driver name',
        enterDriverEmail: 'Please enter the driver email',
        enterDriverPhone: 'Please enter the driver phone number',
        enterPassword: 'Please enter the password',
        enterMerchantName: 'Please enter the merchant name',
        enterMerchantPhone: 'Please enter the merchant phone number',
        enterAddress: 'Please enter the address',
        enterPhoneOrName: 'Please enter at least a name or a phone number',
        confirmDelete: 'Are you sure you want to delete?',
        enterName: 'Please enter the name',
        enterEmail: 'Please enter the email',
        enterInteger: 'Enter a whole number',
        shiftForm: {
            selectWeekDay: 'Please select a day of the week',
            selectStartTime: 'Please select a start time',
            selectEndTime: 'Please select an end time',
            shiftInPast: 'It is not possible to create or modify a shift in the past.',
            invalidHours: 'The end time must be after the start time, on the same day.',
            shiftDeletionPastError: '* It is not possible to delete a shift that has already occurred.',
        },
        shiftDeletionPastInfo: '* However, you can delete shifts for the coming weeks.',
        scheduleForm: {
            selectAtLeastOneTimeSlot: 'Please add at least one time slot',
        },
        chooseAddressOrPhoneNumber: 'Please choose an address or phone number',
        chooseAddress: 'Please choose an address',
        chooseMerchant: 'Please choose a merchant from the list',
        choosePackageSize: 'Please choose a package size',
        chooseService: 'Please choose a service',
        specifyPickupTime: 'Please specify the pickup time',
        pickupTimeRange: 'Pickup time must be between 9am and 8pm',
        specifyDeliveryDeadline: 'Please specify a delivery deadline',
        specifyPickupDeadline: 'Please specify a pickup deadline',
        invalidPhone: 'Phone numbers must be 10 digits (########## or ###-###-####).',
    },
    tracking: {
        title: 'Order tracking',
    },
    common: {
        bulkUnassign: 'Unassign selected orders',
        bulkCancel: 'Cancel selected orders',
        bulkComplete: 'Complete selected orders',
        tryAgain: 'Try Again',
        failedToLoad: 'Failed to load',
        notFound: 'Not Found',
        nA: 'N/A',
        weekly: 'WEEKLY',
        biweekly: '2 WEEKS',
        monthly: 'MONTHLY',
        selection: 'Selection',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        search: 'Search',
        actions: 'Actions',
        back: 'Back',
        cancel: 'Cancel',
        continue: 'Continue',
        yes: 'Yes',
        no: 'No',
        loading: 'Loading...',
        submitting: 'Sending…',
        changePaymentMethod: 'Change Payment Method',
        fetchPaymentMethodError: 'Failed to fetch payment method.',
        genericError: 'An error occurred, please try again later',
        drivers: 'Drivers',
        warnings: 'Warnings',
        optimizeRoute: 'Generate routes',
        mergePickups: 'Merge pickups',
        ignoreTimeWindows: 'Ignore time windows',
        withoutDriversSuggestion: 'Without drivers',
        chooseNbDrivers: 'Choose number of drivers',
        maxRouteDuration: 'Max route time',
        hoursShort: 'h',
        generateRoutes: 'Generate routes for',
        generateRoutesButton: 'Generate routes',
        addTransit: 'Add transit',
        pickupProblem: 'Pickup problem',
        deliveryProblem: 'Failed delivery',
        addTransitInfoStorage: 'This form is for temporary storage at a transit hub.',
        addTransitInfoDeposit: 'The driver drops off the packages; another pickup will be scheduled later.',
        addTransitInfoSplitInstead: 'If the driver keeps the packages, use',
        splitPickupDelivery: 'Split pickup/delivery',
        splitPickupDeliveryAlreadySplit: 'This delivery is already split (pickup-only or delivery-only).',
        splitPickupDeliveryAlreadySplitBulk: 'These deliveries are already split (pickup-only or delivery-only).',
        splitPickupDeliveryAlreadySplitIgnored: '{count} already-split delivery(ies) will be ignored.',
        reunitePickupDelivery: 'Reunite pickup/delivery',
        reunitePickupDeliveryBulkTitle: 'Reunite pickup/delivery ({count} deliveries)',
        reunitePickupDeliverySubmit: 'Reunite',
        reunitePickupDeliverySubmitCount: 'Reunite ({count})',
        reunitePickupDeliveryInfoKeep: 'A single delivery will be kept; the second delivery will be removed.',
        reunitePickupDeliveryInfoBeforePickup: 'If pickup is not done, the dropoff stop returns on the current route.',
        reunitePickupDeliveryInfoAfterPickup: 'If pickup is already done, it stays completed; only the dropoff is restored.',
        reunitePickupDeliveryBlocked: 'Cannot reunite: this is not a split pickup/delivery, or the delivery is already completed or cancelled.',
        reunitePickupDeliveryNone: 'No split delivery to reunite.',
        reunitePickupDeliveryNoneBulk: 'None of these deliveries can be reunited.',
        reunitePickupDeliveryIgnored: '{count} delivery(ies) that are not split or already completed will be ignored.',
        reunitePickupDeliveryNoDelivery: 'No active delivery found.',
        reunitePickupDeliveryError: 'An error occurred',
        parentLegIncomplete: 'Warning: the previous pickup/segment is not completed yet.',
        selectedOrders: 'selected orders',
        timeWindowsIgnored: {
            title: 'Time windows have been ignored',
            description: 'It is impossible to deliver all orders respecting their time windows while merging pickups for the selected orders.',
            descriptionSimple: 'Some orders cannot be delivered within their time windows.'
        },
        timeWindowsViolation: {
            title: 'The following orders do not respect their time window:'
        },
        labels: {
            distance: 'Distance',
            duration: 'Duration',
            km: 'KM'
        },
        confirmRemoveRoute: 'Are you sure you want to remove this route? Orders will be returned to the unassigned orders list.',
        confirmAcceptRoute: 'Are you sure you want to generate this route?',
        confirmAcceptAllRoutes: 'Are you sure you want to generate {count} route(s)?',
        acceptingRoutes: 'Accepting...',
        acceptRoute: 'Accept route',
        removeRoute: 'Remove route',
        acceptRoutes: 'Accept routes',
        noDriver: 'Unassigned',
        headers: {
            price: 'Price',
            itinerary: 'Route',
            completedStops: 'Completed Stops',
            distance: 'Distance',
            duration: 'Duration',
            driver: 'Driver',
            actions: 'Actions',
            commerce: 'Commerce',
            address: 'Address',
            openingTime: 'Opening Time',
            closureTime: 'Closing Time',
            day: 'Day'
        },
        allOrdersAssigned: 'All orders are assigned',
        noUnassignedOrders: 'No unassigned orders',
        unassignedOrders: 'Orders without route',
        unassignedOrdersSubtitle: 'These orders are not assigned to a route',
        actions: {
            filter: 'Filter',
            clear: 'Clear',
            add: 'Add',
            cancel: 'Cancel',
            modify: 'Modify',
            delete: 'Delete',
            save: 'Save',
            confirm: 'Confirm',
            next: 'Next',
            return: 'Return',
            selectRole: 'Select a role',
            useDifferentOrigine: 'Use a different pickup address',
            useSameOrigine: 'Use my current address',
            deleteShift: 'Delete this shift',
            optimizeRoute: 'Optimize route',
            reoptimizeFullRoute: 'Re-optimize entire route',
            mergePickups: 'Merge pickups',
            ignoreTimeWindows: 'Ignore time windows',
            selectStartPoint: 'Add start point',
            removeStartPoint: 'Remove start point'
        },
        orderFees: {
            addExtraFee: 'Add extra fee',
            additionalFee: 'Additional fee',
            amountLabel: 'Amount',
            appliesToDelivery: 'Applies to delivery',
            baseCommission: 'Base commission',
            billedToMerchantAndGivenToDriver: 'Billed to merchant and given to driver',
            bonus: 'Bonus',
            cannotRetrieveFees: 'Unable to retrieve fees for this order, please try again later',
            chooseBonus: 'Choose a bonus',
            chargeOrderAnyway: 'Charge anyway',
            chargeOrderAnywayHelp: 'Include this cancelled order on the merchant invoice.',
            confirmRefund: 'Are you sure you want to refund this client?',
            customFee: 'Custom fee',
            customFeeLabel: 'Custom fee label',
            customFeeLabelRequired: 'Label is required for custom fee.',
            driver: 'Driver',
            driverSharePct: 'Driver share %',
            extraFees: 'Extra fees',
            fixedFee: 'Fixed fee',
            internalFee: 'Internal fee',
            merchant: 'Merchant',
            minutesWaited: 'Minutes waited',
            otherOption: 'Other',
            otherReason: 'Reason for this fee',
            percentageOnInvoiceAmount: '% on invoice amount',
            refundClient: 'Refund client',
            totalDriver: 'Total driver',
            totalMerchant: 'Total merchant',
            typeLabel: 'Type',
            waitingFee: 'Waiting fee'
        },
        save: 'Save',
        saving: 'Saving...',
        messages: {
            savedSuccessfully: 'Changes saved successfully'
        },
        businessHours: {
            title: 'Business Hours',
            enableBusinessHours: 'Set business hours (optional)',
            optionalNote: 'Business hours are optional. Enable this option to set your business opening hours.',
            serviceFlexible: 'Flexible',
            serviceEntreprise: 'Business',
            servicePonctuel: 'Punctual',
            serviceDirect: 'Direct',
            serviceUnavailable: 'The {{services}} service will not be available for this day.',
            sameForAllDays: 'Use the same hours for all days',
            closed: 'Closed',
            openingHoursForDay: 'Opening hours for this day are from {{openingTime}} to {{closureTime}}.',
            modifyHoursInSettings: 'You can modify the opening hours in the merchant settings.',
            modifyHours: 'Modify opening hours',
            removeStartPoint: 'Remove start point',
            confirm: 'Confirm',
            save: 'Save',
            modify: 'Modify',
            add: 'Add',
            delete: 'Delete',
            deleteShift: 'Delete this shift',
            return: 'Return',
            next: 'Next',
            filter: 'Filter',
            selectRole: 'Select a role',
            useDifferentOrigine: 'Use a different pickup address',
            useSameOrigine: 'Use my current address'
        },
        billing: {
            addPaymentMethodRequired: 'Please add a payment method to continue.',
            addPaymentMethod: 'Add payment method',
            outstandingBalanceWarning: 'Your account could be suspended if no payment is received.',
            outstandingBalanceWarningDetailed: 'ATTENTION! You have an unpaid balance of {{amount}}$ overdue by more than {{days}} days.\n\nService may be suspended soon.\nPlease make a payment.',
            accountSuspendedOutstandingBalance: 'Your account is suspended due to an outstanding balance. Please make a payment to continue.',
            accountSuspendedOutstandingBalanceDetailed: 'ATTENTION! Your account is suspended. You have an unpaid balance of {{amount}}$ overdue by more than {{days}} days.\n\nPlease make a payment to restore service.',
            goToBilling: 'Go to billing',
            viewAndPayInvoices: 'View and pay invoices',
        },
        shiftForm: {
            deleteShiftAndWeeks: 'Delete this shift and coming weeks',
            deleteWeeksKeepShift: 'Delete coming weeks and keep this shift',
            taskDescription: 'Task description / Prerequisites',
            comments: 'Comments',
            recurringShift: 'Recurring shift (repeats every week)',
            hourlyFee: 'Hourly fee',
            estimatedDuration: 'Estimated duration',
            estimatedTotal: 'Estimated total',
            pricingPending: 'Enter a start and end time to see the estimated total.',
            estimatedTotalHint: 'Estimate before taxes, based on the planned duration and your hourly fee. The invoice follows the confirmed hours.',
            confirmEstimateHint: 'Estimate before taxes, based on the hours being confirmed.',
            perOccurrence: 'This amount applies to each weekly occurrence.',
            pricingUnavailable: 'Unable to load the hourly fee. Please try again later.',
            dayOfWeek: 'Day of the week',
            chooseDayOfWeek: 'Choose a day of the week'
        },
        scheduleForm: {
            addTimeSlot: 'Add a time slot'
        },
        headers: {
            commerce: 'Commerce',
            day: 'Day',
            openingTime: 'Opening Time',
            closureTime: 'Closing Time',
            startTime: 'Start time',
            endTime: 'End time',
            timeSlotsList: 'Time slots list',
            actions: 'Actions',
            search: 'Search',
            name: 'Name',
            phoneNumber: 'Phone number',
            billingEmail: 'Billing email',
            address: 'Address',
            city: 'City',
            postalCode: 'Postal code',
            delayByDefault: 'Default delay (h)',
            tackingBySMS: 'Tracking by SMS',
            proofRequired: 'Proof of delivery required',
            price: 'Price',
            distance: 'Distance',
            date: 'Date',
            ordersOrder: 'Order of orders',
            oldPassword: 'Old password',
            newPassword: 'New password',
            confirmNewPassword: 'Confirm new password',
            actions: 'Actions',
            noResult: 'No results',
            noActiveDriver: 'No active driver',
            noDriver: 'No driver',
            busyDrivers: 'Busy drivers',
            offlineShiftDrivers: 'Offline — compatible shift',
            noOfflineShiftDriver: 'No offline driver with a shift covering this route',
            upcomingShiftDrivers: 'Upcoming shifts',
            noUpcomingShiftDriver: 'No drivers with an upcoming shift',
            delete: 'Delete',
            deliveryComment: 'Delivery comment'
        },
        pagination: {
            previous: 'Previous',
            next: 'Next',
            range: '{start} to {end}',
            items: 'items',
            selected: 'selected'
        },
        emailPreferences: 'Email Preferences',
        preference: 'Preference',
        copy: 'Copy',
        changesSaved: 'Changes have been saved',
        saveChanges: 'Save changes',
        seeMore: 'See more',
        phoneNumber: 'Phone number',
        email: 'Email',
        address: 'Address',
        date: 'Date',
        status: 'Status',
        amount: 'Amount',
        filters: {
            start: 'Start',
            end: 'End'
        },
        glossary: {
            merchant: 'Merchant'
        },
        originPickupInputs: {
            comment: 'Pickup comment',
            name: 'Company name',
            nameHint: 'If you\'re not shipping on behalf of a company, enter your name.',
            address: 'Pickup address',
            phone: 'Phone number',
            apartment: 'Apartment'
        },
        addressForm: {
            pickupQuestion: 'What is the pickup address?',
            destinationQuestion: 'Where should we ship?',
            addDestination: 'Add an address',
            businessDiscountTitle: 'Enjoy business discounts',
            businessDiscountSubtitle: 'Does your business ship several parcels per day? Choose a tailored plan.',
            createAccount: 'Create an account',
            login: 'Log in',
            dedicatedIllustrationAlt: 'Dedicated delivery illustration'
        },
        updateRoutePayment: {
            title: 'Update Route Payment',
            routeLabel: 'Route #{routeId}',
            noDriver: 'No driver assigned',
            inputLabel: 'Driver Payment ($)',
            inputPlaceholder: '0.00',
            save: 'Save',
            estimate: 'Estimate',
            cancel: 'Cancel',
            error: 'Failed to update payment'
        },
        addOrderToRoute: {
            selectRouteTitle: 'Select a route',
            unassignedTitle: 'Unassigned routes',
            assignedTitle: 'Assigned routes',
            noRoutes: 'No routes available',
            noUnassignedRoutes: 'No unassigned routes',
            noAssignedRoutes: 'No assigned routes',
            selectRouteAria: 'Select this route'
        },
        routeMaker: {
            ordersOrder: 'Order of orders',
            generateRoute: 'Generate route',
            roadComment: 'Route comment',
            roadScheduled: 'Scheduled time',
        },
        pickupDetails: {
            title: 'Pickup details',
            notifEmailConsignee: 'Send status updates to the recipient by email',
            notifEmailSender: 'Send status updates to the sender by email',
            consigneeEmail: 'Recipient email (tracking)',
            additionalOptionsTitle: 'Almost ready! Before we go, anything else needed?',
            useSMS: 'Send GPS tracking to recipient by SMS',
            useSignature: 'Signature required upon delivery',
            usePOS: 'Collect a payment from the recipient',
            useTip: 'Tip for the driver'
        },
        inputs: {
            Address: 'Address',
            destinationAddress: 'Destination address',
            enterAddress: 'Enter address',
            enterPhoneNumber: 'Enter phone number',
            enterPhoneOrName: 'Phone or name',
            searchSavedDestination: 'Search saved address',
            searchSavedDestinationPlaceholder: 'Name, phone, or address',
            searchSavedDestinationHint: 'Search your saved addresses (name, phone, address, city, postal code)',
            orEnterNewAddress: 'Or enter a new address',
            addressNotFound: 'Address not found?',
            automaticEntry: 'Automatic entry',
            incompletePostalCode: 'The postal code is incomplete. Please complete it before going to the next step.',
            streetNumber: 'Street number',
            street: 'Street',
            postalCode: 'Postal code',
            city: 'City',
            searchAddress: 'Search',
            phoneNumber: 'Phone number',
            andOrAddress: 'and/or the address',
            apartmentNumber: 'Apartment number',
            deliveryComments: 'Delivery comment',
            clientName: 'Client name',
            recipientName: 'Recipient name',
            recipientNameorCorporation: 'Recipient or company name',
            aboutDestinationComments: 'Notes about the recipient',
            firstname: 'First name',
            email: 'Email',
            role: 'Role',
            tmpPassword: 'Temporary password',
            confirmPassword: 'Confirm password'
        },
        questions: {
            apartmentNumber: 'Apartment number'
        },
        destinationOptions: {
            sendGPSTrackingSMS: 'Send GPS tracking to client via SMS',
            proofRequired: 'Proof of delivery required',
            signatureRequired: 'Signature required',
            collectAmount: 'Collect an amount',
            tipToDriver: 'Tip to driver',
            amountToCollect: 'Amount to collect',
            amountToCollectPlaceholder: 'Amount to collect ($)',
            posPaymentDescription: 'Contactless payment only (Tap, Apple Pay, Google Pay). Card insertion and PIN are not supported.',
            posPaymentPolicyLink: 'Read the door payment collection policy',
            tipAmount: 'Tip amount',
            tipAmountPlaceholder: 'Tip amount $'
        },
        orderForm: {
            nextStep: 'Next step',
            confirmAndPay: 'Confirm and pay',
            cannotProvideService: 'We cannot provide the service at this time, please try again later.',
            serviceNotAvailable: 'Our services are not currently available at your address.',
            packageWeightExceeded:
                'The package weight exceeds the accepted limit (max {{maxKg}} kg / {{maxLbs}} lbs). Please reduce the weight to get a price.',
            invalidPromoCode: 'Invalid promo code',
            promoValidationError: 'Error validating promo code',
            choosePickupAndDestination: 'Please choose a pickup and destination address from the dropdown list.',
            specifyAllFields: 'Please specify all fields marked with an asterisk "*".',
            orderAddedSuccess: 'Order added successfully!',
            shipmentCreatedTitle: 'Scheduled shipment',
            shipmentCreatedPickupSubheading: 'Pickup scheduled for {{window}}',
            shipmentCreatedPickupSubheadingWithCarrier: 'Pickup by {{carrier}} scheduled for {{window}}',
            summaryEmailSent: 'A summary of your delivery will be sent to your email shortly.',
            trackingNumber: 'Tracking number',
            referenceNumber: 'Reference number',
            onlineTracking: 'Online tracking',
            printLabelMandatoryPrefix: 'Required — ',
            printLabelOptionalPrefix: 'Optional — ',
            printLabelImportant:
                'Print the shipping label and fix it to your package before pickup.',
            printLabel: 'Print label',
            printLabelHint: 'Print your label here or later from your order history.',
            printLabelLater: 'Print later',
            printLabelDeferModalTitle: 'Get the print link',
            printLabelDeferIntro:
                'Send yourself the shipping-label print link by email or SMS (standard carrier rates may apply to SMS).',
            printLabelDeferChannelLabel: 'Method',
            printLabelDeferChannelEmail: 'Email',
            printLabelDeferChannelSms: 'SMS',
            printLabelDeferPhoneLabel: 'Phone number',
            printLabelDeferPhonePlaceholder: 'e.g. 514 555 0123',
            printLabelDeferEmailLabel: 'Email address',
            printLabelDeferEmailPlaceholder: 'you@example.com',
            printLabelDeferSubmit: 'Send',
            printLabelDeferSuccess: 'Sent.',
            printLabelDeferError: 'Could not send. Please try again.',
            printLabelDeferInvalidLink: 'Invalid print link.',
            trackOnline: 'Track shipment',
            trackOnlineHint: 'Open the carrier tracking page for live updates.',
            nextStepsTitle: "You're not done yet — here are the next steps…",
            temporaryPasswordTitle: 'Your temporary password',
            temporaryPasswordPortal:
                'Log in to your client portal with this password to view your shipping history and access bulk discounts.',
            loginToPortal: 'Log in to client portal',
            copyPassword: 'Copy',
            passwordCopied: 'Copied',
            shipmentSuccessDone: 'Done',
            merchantDashboardLink: 'Open merchant dashboard',
            whenDoYouNeed: 'When do you need it?',
            summaryPickupWindowLabel: 'Pickup window',
            summaryDeliveryLabel: 'Delivery',
            summaryPickupDateTimeSeparator: '·',
            summaryDeliveryBeforeTime: 'Before {{time}}',
            summaryScheduleLaterNotice:
                'To be scheduled later in your client portal; a temporary password will be emailed to you',
        },
        payment: 'Payment',
        now: 'Now',
        plan: 'Schedule',
        atMerchant: 'At merchant',
        atClient: 'At client',
        paymentMethod: 'Payment method',
        paymentMethods: {
            alreadyPaid: 'Already paid',
            cash: 'Cash',
            debit: 'Debit',
            credit: 'Credit'
        },
        paymentTypeForm: {
            title: 'Payment method',
            alreadyPaid: 'Already paid',
            cash: 'Cash',
            debit: 'Debit',
            credit: 'Credit',
            POSComptant: 'POS-Comptant',
            comptantDebit: 'Comptant-Debit',
            comptantCredit: 'Comptant-Credit',
            invoiceAmount: 'Invoice amount',
            tip: 'Tip',
            alreadyPaidHelp: 'No payment needs to be collected, or the merchant arranged payment directly with the driver',
            cashHelp: 'The customer pays cash and the driver keeps the money',
            debitHelp: 'The customer pays with a debit card',
            creditHelp: 'The customer pays with a credit card'
        },
        invoiceAmount: 'Invoice amount',
        time: 'Time',
        optional: 'Optional',
        packageCount: 'Number of packages',
        content: 'Content',
        whatAreWeSending: 'What are we sending?',
        moreInfoOnFormats: 'More info on formats',
        bubbleContent: {
            approximateSize: 'Approximate size',
            examples: 'Examples',
            small: {
                title: 'Envelope',
                transportMethod: 'Fits in one hand',
                maxSpecMetric: 'Up to ~ 30cm and 1kg',
                maxSpecImperial: '~ 12in and 2lbs',
                sizeDescription: 'Up to ~ 30cm and 1kg ~ 12in and 2lbs',
                examples: 'E.g.: mail, small bag'
            },
            medium: {
                title: 'Parcel',
                transportMethod: 'Carried with one hand',
                maxSpecMetric: 'Up to ~ 30cm and 5kg',
                maxSpecImperial: '~ 12in and 10lbs',
                sizeDescription: 'Up to ~ 30cm and 5kg ~ 12in and 10lbs',
                examples: 'E.g.: box, large bag, package'
            },
            large: {
                title: 'Large',
                transportMethod: 'Carried with two hands',
                maxSpecMetric: 'Up to ~ 1m and 20kg',
                maxSpecImperial: '~ 3ft and 45lbs',
                sizeDescription: 'Up to ~ 1m and 20kg ~ 3ft and 45lbs',
                examples: 'E.g.: large box, small furniture'
            },
            registered: {
                title: 'Registered mail',
                transportMethod: 'Delivered the same day. Real-time tracking and a receipt for the sender proving deposit and handover against signatures. Your mail is returned if delivery to the recipient is impossible.',
                maxSpecMetric: 'Max. 2.5–4.5 kg',
                maxSpecImperial: 'Max. 5–10 lb',
                sizeDescription: 'Max. 5–10 lb (2.5–4.5 kg)',
                examples: 'Envelope / small mail with signature',
                selectionNote: 'Signature required on delivery, otherwise the package is returned to you.',
            }
        },
        packageDimensions: {
            title: 'Package Dimensions',
            outsideServiceZone: 'This destination is outside our service zone. Please provide exact package dimensions.',
            length: 'Length (cm)',
            width: 'Width (cm)',
            height: 'Height (cm)',
            weight: 'Weight (kg)',
            lengthPlaceholder: 'Length in cm',
            widthPlaceholder: 'Width in cm',
            heightPlaceholder: 'Height in cm',
            weightPlaceholder: 'Weight in kg',
            lengthIn: 'Length (in)',
            widthIn: 'Width (in)',
            heightIn: 'Height (in)',
            weightLbs: 'Weight (lbs)',
            lengthPlaceholderIn: 'Length in inches',
            widthPlaceholderIn: 'Width in inches',
            heightPlaceholderIn: 'Height in inches',
            weightPlaceholderLbs: 'Weight in lbs',
            unitsLabel: 'Units',
            unitsMetric: 'cm / kg',
            unitsImperial: 'in / lbs',
            required: 'All dimensions are required for extended delivery',
            packageNumberLabel: 'Package',
            quantity: 'Quantity',
            distinctPackageTypes: 'Different package sizes',
            addPackageFormat: 'Add a format',
            removePackageFormat: 'Remove this format',
            carrierModalTitle: 'Package dimensions',
            carrierModalIntro: 'Enter the exact dimensions for each package so we can quote third-party delivery accurately.',
            carrierModalConfirm: 'Confirm and update price',
            carrierModalValidation: 'Please enter length, width, height and weight for each package.',
            calculatePrice: 'Calculate price',
            defaultsHeading: 'Default package dimensions',
            defaultsHelp: 'Used automatically when exact dimensions are required.',
            defaultsIncomplete: 'Enter length, width, height and weight, or leave all fields empty.',
            defaultsAutofilled: 'Values filled from your default package dimensions.',
            defaultsSettingsLink: 'Edit default dimensions',
            shippingBoxesHeading: 'Shipping boxes',
            shippingBoxesHelp: 'Add the boxes you ship with. The default box is used when exact dimensions are required.',
            shippingBoxesEmpty: 'Add the boxes you ship with. The default box is used for orders that need package dimensions.',
            shippingBoxName: 'Box name',
            shippingBoxMaxWeight: 'Max weight',
            shippingBoxEmptyWeight: 'Empty weight (optional)',
            shippingBoxDefault: 'Default',
            shippingBoxSetDefault: 'Set as default',
            shippingBoxAdd: 'Add box',
            shippingBoxRemove: 'Remove',
            shippingBoxIncomplete: 'Each box needs a name, length, width and height.',
            shippingBoxSkippedOnProfileSave: 'Profile saved. Complete or remove unfinished shipping boxes to save them too.',
            shippingBoxClearConfirm: 'Remove every shipping box? Orders will no longer have a default box.',
        },
        servicePart: {
            planForLaterDate: 'Plan for a later date',
            planAndSave: 'Plan and save',
            startingFrom: 'Starting from',
            flexibleRateInfo: 'To benefit from the same-day flexible delivery rate, the delivery must be sent before 1pm.',
            flexibleRateInfoOutsideZone: 'Our 4-hour service is not yet available at your address. However, we offer an express service through our extended partner network.',
            service: 'Service',
            deliveryDate: 'Delivery date',
            rate: 'Price',
            choose: 'Choose',
            deliveryServicesTitle: 'Delivery services',
            seeShippingOptions: 'See shipping options',
            sortBy: 'Sort by :',
            daysUnit: 'day(s)',
            deliveryDateToday: 'Today',
            deliveryDateTomorrow: 'Tomorrow',
            deliveryDateInDaysPrefix: 'Within',
            deliveredPrefix: 'Delivered',
            ishipExpress: 'Express',
            ishipEconomique: 'Economy',
            ishipExpressGaranti: 'Express guaranteed',
            posteCanadaNoPickup: 'Canada Post',
            posteCanadaNoPickupLabel: '⚠️ Pickup not included',
            posteCanadaDeliveryRange: '1 - 2 business days',
            ishipExpressDeliveryRange: '1 business day',
            ishipEconomiqueDeliveryRange: '1 - {{days}} business days',
            ishipExpressPickupRange: 'Pickup in 24h or less',
            ishipPickupRange: 'Pickup in 48h or less',
            nextDayDeliveryRange: 'Delivery in 24-48h',
            preferredTitle: 'Express',
            cascadeSameDay: 'same-day',
            cascadeNextDay: 'Next-day',
            cascadeMultilegPosteCanada: 'Multileg - Canada Post',
            cascadeMultilegCarrier: 'Multileg - {{carrier}}',
            cascadeMultilegEcono: 'Multileg - econo',
            cascadeMultilegExpress: 'Multileg - express',
            cascadeEconomy: 'Economy',
            cascadeEconomyCarrier: 'Economy - {{carrier}}',
            interurbanGroup: 'Intercity',
            sameDayServicesGroup: 'Same-day services',
            ishipViaPartner: 'Via our partner network',
            livraisonRabaisViaPartner: 'Via our partner network',
            partnerCarrier: 'Partner carrier',
            thirdPartyOrderSummarySuffix: ' - Service operated through our partner network',
        },
        scheduleRecurring: {
            dayPickup: 'Day (pickup at merchant)',
        },
        pickupTime: 'Pickup time',
        pickupDate: 'Pickup date',
        secondLegPickupDate: 'Pickup date of the second delivery leg',
        deliveryDeadline: 'Delivery deadline',
        mins: 'mins',
        hours: 'h',
        delayForm: {
            title: 'Modify preparation time',
            now: 'Now',
            toPlan: 'Schedule',
            pickupHere: 'To be picked up by:',
            date: 'Date',
            hour: 'Time',
            hourFrom: 'From',
            hourTo: 'To',
            hourRange: 'Pickup time range',
            hourRangeInvalid: 'End time must be after start time.',
            hourRangeRequired: 'Choose a date and a time range (from – to).',
            noPickupSlots: 'No pickup time is available for this date. The business is closed or the hours have passed.',
            selectDate: 'Select...',
            selectHour: 'Choose...',
            pickupDeadline: 'Pickup deadline',
            defineTimeDeadline: 'Define a delivery deadline time',
            dateDeadline: 'Date (delivery deadline)',
            timeDeadline: 'Time (delivery deadline)',
            modifyDelay: 'Modify delay',
            modifyServicePrice: 'Modify service/price',
            deadlineShiftPreview: 'Deliver-before will move to {when}.',
            deadlineShiftPreviewMany: 'Deliver-before will move for {count} deliveries.',
        },
        delayPart: {
            specifyTime: 'Specify time',
            spotServiceHours: 'Spot service hours: 09:00 to 17:00',
            directServiceHours: 'Direct service hours: 10:00 to 20:00',
            contactForOtherHours: 'Contact us for shipments outside these hours',
            schedulePickupLater: 'Schedule pickup later',
            schedulePickupLaterPortalHint: 'You can schedule your pickup later via the customer portal. A temporary password will be sent to you by email after confirming your shipment.',
            thirdPartyPickupHintDateOnly: 'Pickup: date only (time window may be set on the carrier portal if applicable).',
            thirdPartyPickupWindowDisclaimer:
                'Pickup dates and times for this service cannot be guaranteed. The carrier will try to accommodate them. Your pickup date and time will be updated and confirmed via the tracking link you will receive.',
            posteCanadaDropoffNotice: 'Pickup is not included. Drop your parcel off at a Canada Post office.',
            posteCanadaFindOffice: 'Find a post office nearby',
            obiboxNextDayMinPickupWindow: 'For this service, a minimum 6-hour pickup window is required.',
        },
        links: 'Links',
        transportRequestForm: 'Transport request form',
        apiKey: 'API Key',
        business: 'Edit business information',
        today: 'Today',
        tomorrow: 'Tomorrow',
        deliveryServices: {
            title: 'Delivery service',
            getPricing: 'Get pricing',
            getPricingFirst: 'Enter the destination address and package size above, then click to get available services and pricing.',
            fromTomorrow: 'From Tomorrow',
            planned: 'Planned',
            direct: 'Direct',
            punctual: 'Punctual',
            flexible: 'Flexible',
            business: 'Business',
            thirdParty: 'Standard',
            nextDay: 'Next Day',
            nextDayToday: 'Picked up today',
            nextDayTomorrow: 'Picked up tomorrow',
            nextDayPlanned: 'Picked up tomorrow',
            deliveryIn: 'Delivered in',
            oneDay: '1 day',
            daysUnit: 'days',
            nextDayDescription: 'Delivered next business day after pickup',
            twoDays: '2 Days',
            twoDaysToday: 'Picked up today',
            twoDaysTomorrow: 'Picked up tomorrow',
            twoDaysPlanned: 'Picked up tomorrow',
            twoDaysDescription: 'Delivered in 2 business days (non-urgent)',
            skipGround: 'Skip Ground (Iship)',
            skipGroundTitle: 'Skip Ground',
            skipGroundDescription: 'Delivery in X business days (from Iship quote)',
            skipGroundTransitDays: '{{count}} transit day(s)',
            hubSkipGroundTimeToday: 'Picked up today, delivery per Iship quote',
            hubSkipGroundTimePlanned: 'Picked up tomorrow, delivery per Iship quote',
            hubPickupTime: 'Picked up between 9am and 5pm',
            hubNextDayTimeToday: 'Picked up today, delivered tomorrow',
            hubNextDayTimePlanned: 'Picked up tomorrow before 5pm, delivered the next day',
            hubTwoDaysTimeToday: 'Picked up today, delivered in 2 days',
            hubTwoDaysTimePlanned: 'Picked up tomorrow before 5pm, delivered in 2 days',
            fastPickupNextDayTitle: 'Picked up in 4h window, delivered tomorrow',
            fastPickupNextDayTimeToday: 'Picked up today, delivered tomorrow',
            fastPickupNextDayTimePlanned: 'Picked up tomorrow in a 4-hour window, delivered the next day',
            urgentTime: 'Pickup in 60 minutes and delivered directly',
            fastTime: 'Picked up and delivered in 4h according to your schedule.',
            sameDayTime: 'Picked up before 5pm. Delivered before 9pm.',
            businessTime: 'Picked up and delivered before 5pm',
            thirdPartyTime: 'Picked up between 9am and 5pm',
            thirdPartyToday: 'Picked up today',
            thirdPartyTomorrow: 'Picked up tomorrow',
            thirdPartyPlanned: 'Picked up tomorrow',
            thirdPartyDescription: 'Shipped 1-2 business days after pickup',
            doorToDoorPickupScheduled: 'Pickup scheduled on',
            scheduleTime1h: 'Schedule the time, delivered in 1h',
            scheduleTime4h: '4-hour pickup window, starting from:',
            morningSlot: 'AM (Picked up from 9am and delivered before 1pm)',
            afternoonSlot: 'PM (Picked up from 1pm and delivered before 5pm)',
            eveningSlot: 'Evening (Picked up from 5pm and delivered before 9pm)',
            morningSlot1h: 'AM (1h pickup window, starting from 9am)',
            afternoonSlot1h: 'PM (1h pickup window, starting from 1pm)',
            eveningSlot1h: 'Evening (1h pickup window, starting from 5pm)',
            readyNow: 'Ready now'
        },
        daysOfWeek: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
        ],
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        orderStatus: {
            toConfirm: 'A CONFIRMER',
            onWait: 'EN ATTENTE',
            assigned: 'ASSIGNÉ',
            headingToPickup: 'EN DIRECTION',
            arrived: 'ARRIVÉ',
            pickedUp: 'RÉCUPÉRÉE',
            onTheWay: 'EN ROUTE',
            cancelled: 'ANNULÉ',
            failed: 'ÉCHEC',
            refused: 'REFUSÉE',
            delivered: 'LIVRÉ',
            attention: 'ATTENTION',
            transit: 'TRANSIT',
            returning: 'EN RETOUR',
            returned: 'RETOUR',
            reactivate: 'Reactivate to pending',
            reactivateHelp: 'This will reactivate the cancelled order and set it back to pending.'
        },
        orderView: {
            title: 'Edit Order',
            statut: 'Status',
            driver: 'Driver',
            distanceToOrigin: 'Distance to merchant',
            distanceToClient: 'Distance to client',
            unassign: 'Unassign',
            assignDriver: 'Assign a driver',
            modify: 'Edit',
            modifyFees: 'Modify fees $',
            modifyStatus: 'Modify status',
            updateDelay: 'Update delays',
            delayUpdateCurrentService: 'Current service:',
            completeOrder: 'Completed',
            cancelOrder: 'Cancel',
            pickup: 'Pickup',
            delivery: 'Delivery',
            confirmOrder: 'Confirm Order',
            confirmPickup: 'Confirm pickup',
            confirmPickupSubmit: 'Confirm',
            confirmPickupCancel: 'Cancel',
            confirmPickupQuoteFallback: 'Live pricing unavailable — pickup options are based on this order.',
            confirmPickupQuoteUnavailable: 'Live pricing is unavailable and this order has no stored delivery fee. Please try again later.',
            details: 'Details',
            statusSection: 'Status',
            delays: 'Deadlines',
            fees: 'Fees',
            actions: 'Actions',
            assigned: 'Assigned',
            arrived: 'Arrived',
            pickedUp: 'Picked up',
            onTheWay: 'On the way',
            completed: 'Completed',
            canceledAt: 'Canceled',
            thirdParty: 'Third-party delivery',
            amount: 'Amount',
            route: 'Route',
            orderHeading: 'Order #{{id}}',
            format: 'Format',
            box: 'box',
            boxes: 'boxes',
            podRequired: 'Proof of delivery required',
            signatureRequired: 'Signature required',
            paymentRequired: 'Payment required',
            podReceived: 'Proof of delivery received',
            registeredMailReturnNote: 'Registered mail: on failed delivery, plan a free return to the sender.',
        },
        cancelView: {
            title: 'Are you sure you want to cancel?',
            cancelOrder: 'Cancel order',
            specifyReason: '(Optional) Specify the reason',
            noDriverAvailable: 'No driver available',
            deliveryProblem: 'Problem during delivery',
            orderNotReady: 'Order not ready',
            clientAddressNotFound: 'Client address not found',
            inactifClient: 'Inactive client',
            orderContentTooBig: 'Order content too large'
        },
        trackingLink: 'Tracking link',
        printDeliveryLabel: 'Print shipping label',
        sendToEmail: 'Send by email',
        send: 'Send',
        trackingLinkSent: 'Tracking link sent to',
        errors: {
            fetchTrackingLink: 'Failed to fetch tracking link',
            sendTrackingLink: 'Failed to send tracking link. Please try again.',
        },
        enterValidEmail: 'Please enter a valid email address',
        pickup: 'Pickup',
        destination: 'Destination',
        servicesNotAvailable: 'Our services are not currently available at your address.',
        assignToMyDrivers: 'Assign to my drivers',
        subcontractToOnShip: 'Subcontract to OnShip Ça!',
        deliveryDelays: 'Delivery delays',
        calculatedDistance: 'Calculated distance',
        deliveryDeadlines: 'Delivery deadlines',
        assignDriver: 'Assign a driver',
        waitingDrivers: 'Waiting drivers',
        vehicleVolume: {
            label: 'Vehicle volume',
            beforeAfter: '{before}% → {after}%',
            currentCapacity: 'Current capacity',
            afterCapacity: 'After',
            capacityUnknown: 'capacity unknown',
            riskFull: 'Vehicle risk of being full',
        },
        shiftWarning: 'Shift does not cover the route time window.',
        shiftWindow: 'Shift {start}–{end}',
        compatibleShift: 'Compatible shift',
        compatibleShiftWindow: 'Compatible shift {start}–{end}',
        notAvailableThisDate: 'Not available on this date',
        shiftMismatch: 'Shift mismatch',
        shiftBeforeShift: 'Before shift',
        merchantDriverBlacklist: 'Merchant blacklist',
        tags: {
            assignedDriver: '(Driver assigned)',
            libre: 'Free',
            enRoute: 'On route',
            upcomingShift: 'Shift soon',
        }
    },
    dataTable: {
        actions: 'Actions',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        vehicleType: 'Vehicle type',
        address: 'Address',
        city: 'City',
        category: 'Category',
        filterInclude: 'Include',
        filterExclude: 'Exclude',
        filterClear: 'Clear selection',
        categoryInclude: 'Include these categories',
        categoryExclude: 'Exclude these categories',
        categoryClear: 'Clear selection',
        lastActivity: 'Last activity',
        lifetimeValue: 'Lifetime value',
        postalCode: 'Postal Code',
        status: 'Status',
        date: 'Date',
        inscription: 'Registration',
        onboarding: 'Onboarding',
        onboardingStepsTitle: 'Onboarding steps',
        onboardingStepCompleted: 'Completed',
        onboardingStepPending: 'Pending',
        onboardingTooltipAria: 'Onboarding: {{completed}} of {{total}} steps completed',
        onboardingSteps: {
            formation: 'Training',
            theoric_exam: 'Theory exam',
            account_info: 'Personal info',
            tools: 'Work tools',
            appointment: 'Account activation',
            material: 'Equipment',
        },
        time: 'Time',
        delay: 'Delay',
        content: 'Content',
        amount: 'Amount',
        driver: 'Driver',
        merchant: 'Merchant',
        destination: 'Destination',
        pickup: 'Pickup',
        delivery: 'Delivery',
        deadline: 'Deadline',
        commission: 'Commission',
        fees: 'Fees',
        price: 'Price',
        distance: 'Distance',
        duration: 'Duration',
        route: 'Route',
        routes: 'Routes',
        completedStops: 'Completed Stops',
        confirmed: 'Confirmed',
        comments: 'Comments',
        scheduled: 'Scheduled',
        routeCompleted: 'Route Completed',
        estimatedTime: 'Estimated Time',
        actualTime: 'Actual Time',
        merchantPayment: 'Merchant Payment',
        driverPayment: 'Driver Payment',
        testPayment: 'Test Payment',
        timeDifference: 'Actual vs Estimated',
        optimizationPercentage: 'Optimization %',
        experimentalData: 'Experimental data',
        costPerKm: 'Cost / KM',
        avgDistanceBetweenStops: 'Average distance between stops',
        totalDeliveryKm: 'Total delivery KM',
        totalRouteKm: 'Total route KM',
        date2: 'Date 2',
        orders: 'Orders',
        deliveries: 'Deliveries',
        invoices: 'Invoices',
        payments: 'Payments',
        payment: 'Payment',
        method: 'Method',
        receipts: 'Receipts',
        reports: 'Reports',
        users: 'Users',
        user: 'User',
        roles: 'Roles',
        permissions: 'Permissions',
        active: 'Active',
        inactive: 'Inactive',
        online: 'Online',
        offline: 'Offline',
        assigned: 'Assigned',
        unassigned: 'Unassigned',
        completed: 'Completed',
        pending: 'Pending',
        cancelled: 'Cancelled',
        edit: 'Edit',
        delete: 'Delete',
        confirmDelete: 'Are you sure you want to delete this',
        modify: 'Modify',
        rates: 'Rates',
        view: 'View',
        add: 'Add',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        import: 'Import',
        download: 'Download',
        upload: 'Upload',
        exportPODs: 'Export PODs',
        item: 'item',
        items: 'items',
        selected: 'selected',
        generate: 'Generate',
        print: 'Print',
        send: 'Send',
        receive: 'Receive',
        start: 'Start',
        end: 'End',
        pause: 'Pause',
        resume: 'Resume',
        stop: 'Stop',
        close: 'Close',
        open: 'Open',
        show: 'Show',
        hide: 'Hide',
        expand: 'Expand',
        collapse: 'Collapse',
        refresh: 'Refresh',
        reload: 'Reload',
        update: 'Update',
        create: 'Create',
        remove: 'Remove',
        duplicate: 'Duplicate',
        copy: 'Copy',
        paste: 'Paste',
        cut: 'Cut',
        undo: 'Undo',
        redo: 'Redo',
        select: 'Select',
        deselect: 'Deselect',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        noData: 'No data available',
        error: 'Error',
        success: 'Success',
        warning: 'Warning',
        info: 'Information',
        notifications: 'Notifications',
        rowDropdown: {
            ariaLabel: 'More actions for this row',
            assignSuggestion: 'Apply suggestion',
            assignDelivery: 'Assign delivery',
            addDeliveryToRoute: 'Add to Route',
            editDelay: 'Edit delay',
            viewOrderDetails: 'View order',
            sendTrackingShare: 'Tracking link',
            remunerationRates: 'Remuneration rates',
            bankingSetup: 'Bank payouts',
            merchantCommissionEdit: 'Edit commissions',
            changePasswordDriver: 'Password',
            merchantUsersManage: 'Merchant users',
            recurringPricing: 'Edit pricing',
            viewInvoicePdf: 'View invoice',
            emailInvoicePdf: 'Email invoice',
            depositReconciliationInvoice: 'Credit card reconciliation',
            listCreditCardRefunds: 'View card refunds',
            exportOrdersCsvDetail: 'Download CSV line items',
            payInvoiceCard: 'Pay invoice',
            proofOfDelivery: 'Proof of delivery',
            proofOfDeliveryUnavailable: 'Proof of delivery (unavailable)',
            proofOfDeliveryUnavailableHint: 'No proof of delivery was captured for this order.',
            carrierTrackingUnavailableHint: 'Carrier tracking is not available yet.',
            adjustCommissionDelivery: 'Adjust commissions',
            assignStopsRoute: 'Assign to route',
            routeHideShowOnMap: 'Show / hide route',
            exportThisRoute: 'Export route',
            openRouteDashboard: 'Open route',
            shipmentPrintLabel: 'Print label',
            shipmentCarrierTracking: 'Carrier tracking',
            shipmentEditResubmit: 'Edit shipment',
            shipmentCancelConfirm: 'Cancel shipment',
            shipmentSchedulePickupLar: 'Schedule pickup',
            shipmentCancelPickupLar: 'Cancel pickup',
            shipmentDuplicate: 'Duplicate shipment',
            shipmentChangeCarrier: 'Change carrier',
            reactivate: 'Reactivate',
            viewDriverReceipt: 'View receipt',
            paymentMethodMerchant: 'Payment method',
            businessHoursMerchant: 'Business hours',
            packageDefaultsMerchant: 'Default package dimensions',
        },
        yes: 'Yes',
        no: 'No',
        true: 'True',
        false: 'False',
        enabled: 'Enabled',
        disabled: 'Disabled',
        visible: 'Visible',
        hidden: 'Hidden',
        public: 'Public',
        private: 'Private',
        draft: 'Draft',
        published: 'Published',
        archived: 'Archived',
        deleted: 'Deleted',
        restored: 'Restored',
        approved: 'Approved',
        rejected: 'Rejected',
        pending: 'Pending',
        processing: 'Processing',
        queued: 'Queued',
        running: 'Running',
        stopped: 'Stopped',
        failed: 'Failed',
        completed: 'Completed',
        cancelled: 'Cancelled',
        expired: 'Expired',
        valid: 'Valid',
        invalid: 'Invalid',
        required: 'Required',
        optional: 'Optional',
        primary: 'Primary',
        secondary: 'Secondary',
        tertiary: 'Tertiary',
        urgent: 'Urgent',
        normal: 'Normal',
        low: 'Low',
        high: 'High',
        critical: 'Critical',
        important: 'Important',
        minor: 'Minor',
        major: 'Major',
        total: 'Total',
        subtotal: 'Subtotal',
        tax: 'Tax',
        discount: 'Discount',
        shipping: 'Shipping',
        handling: 'Handling',
        insurance: 'Insurance',
        warranty: 'Warranty',
        refund: 'Refund',
        credit: 'Credit',
        debit: 'Debit',
        balance: 'Balance',
        due: 'Due',
        overdue: 'Overdue',
        paid: 'Paid',
        unpaid: 'Not Paid',
        client: 'Client',
        cost: 'Cost',
        send: 'Send',
        generate: 'Generate',
        invoice: 'Invoice',
        creationDate: 'Creation Date',
        displayCompletedOrders: 'Display completed orders',
        orderView: {
            title: 'Edit Order',
            statut: 'Status',
            driver: 'Driver',
            distanceToOrigin: 'Distance to merchant',
            distanceToClient: 'Distance to client',
            unassign: 'Unassign',
            assignDriver: 'Assign a driver',
            modify: 'Edit',
            modifyFees: 'Modify fees $',
            modifyStatus: 'Modify status',
            updateDelay: 'Update delays',
            delayUpdateCurrentService: 'Current service:',
            completeOrder: 'Completed',
            cancelOrder: 'Cancel',
            pickup: 'Pickup',
            delivery: 'Delivery',
            confirmOrder: 'Confirm Order',
            confirmPickup: 'Confirm pickup',
            confirmPickupSubmit: 'Confirm',
            confirmPickupCancel: 'Cancel',
            confirmPickupQuoteFallback: 'Live pricing unavailable — pickup options are based on this order.',
            confirmPickupQuoteUnavailable: 'Live pricing is unavailable and this order has no stored delivery fee. Please try again later.',
            details: 'Details',
            statusSection: 'Status',
            delays: 'Deadlines',
            fees: 'Fees',
            actions: 'Actions',
            assigned: 'Assigned',
            arrived: 'Arrived',
            pickedUp: 'Picked up',
            onTheWay: 'On the way',
            completed: 'Completed',
            canceledAt: 'Canceled',
            thirdParty: 'Third-party delivery',
            amount: 'Amount',
            route: 'Route',
            orderHeading: 'Order #{{id}}',
            format: 'Format',
            box: 'box',
            boxes: 'boxes',
            podRequired: 'Proof of delivery required',
            signatureRequired: 'Signature required',
            paymentRequired: 'Payment required',
            podReceived: 'Proof of delivery received',
            registeredMailReturnNote: 'Registered mail: on failed delivery, plan a free return to the sender.',
        },
        cancelView: {
            title: 'Are you sure you want to cancel?',
            cancelOrder: 'Cancel order',
            specifyReason: '(Optional) Specify the reason',
            noDriverAvailable: 'No driver available',
            deliveryProblem: 'Problem during delivery',
            orderNotReady: 'Order not ready',
            clientAddressNotFound: 'Client address not found',
            inactifClient: 'Inactive client',
            orderContentTooBig: 'Order content too large'
        },
        trackingLink: 'Tracking link',
        printDeliveryLabel: 'Print shipping label',
        sendToEmail: 'Send by email',
        trackingLinkSent: 'Tracking link sent to',
        errors: {
            fetchTrackingLink: 'Failed to fetch tracking link',
            sendTrackingLink: 'Failed to send tracking link. Please try again.'
        },
        enterValidEmail: 'Please enter a valid email address',
        pickup: 'Pickup',
        destination: 'Destination',
        servicesNotAvailable: 'Our services are not currently available at your address.',
        assignToMyDrivers: 'Assign to my drivers',
        subcontractToOnShip: 'Subcontract to OnShip Ça!',
        deliveryDelays: 'Delivery delays',
        calculatedDistance: 'Calculated distance',
    },
    dashboard: {
        action1: 'Make a shipment',
        action2: 'Dedicated drivers',
        actions: {
            addOrder: 'Make a shipment',
            addToRoad: 'Add to route',
            assignRoad: 'Assign route',
            cancel: 'Cancel',
            closeRoad: 'Close route',
            colorOrdersByRoad: 'Identify routes',
            createRoad: 'Create route',
            displayCompletedOrders: 'Display completed orders',
            displayTodaySchedule: 'Display today\'s schedule',
            exportRoads: 'Export routes',
            generateRoad: 'Generate route',
            import: 'Import',
            info: 'Info',
            map: 'Map',
            offline: 'Offline',
            pay: 'Pay invoices',
            save: 'Save',
            updateRoad: 'Update route'
        },
        actionsassign: 'Assign',
        activeRoutes: '{count} active routes',
        comments: 'Reviews',
        completedDedicatedServices: 'Completed work shifts',
        completedOrders: 'Delivered orders',
        credits: 'Discount credits',
        cycle: 'Recurrence',
        dataHistory: 'History - Last 30 days',
        discoverDriverPlacementService: {
            link: 'Discover our driver placement service',
            tail: 'and track your drivers on the map with <b>GPS technology</b>.'
        },
        driver: {
            prioritize: 'Prioritize',
            setAvailable: 'Make available',
            setDoNotDisturb: 'Do not disturb',
            status: {
                doNotDisturb: 'Do not disturb',
                inDelivery: 'In delivery'
            },
            unprioritize: 'Un-prioritize'
        },
        drivers: 'Drivers',
        error: 'An error occurred, please try again later',
        importSuccess: 'orders imported successfully',
        importFailed: 'Import failed',
        importError: 'An error occurred during import',
        csvImport: {
            title: 'Import orders (CSV)',
            upload: 'Upload',
            map: 'Map columns',
            back: 'Back',
            preview: 'Preview',
            progress: 'Creating',
            pickup: 'Pickup',
            downloadTemplate: 'Download CSV template',
            chooseFile: 'Choose CSV file…',
            nextPreview: 'Analyze file',
            confirmMapping: 'Continue to preview',
            mapHint: 'Review how CSV headers map to import fields. Highlighted rows need confirmation.',
            sourceHeader: 'CSV header',
            targetField: 'Import field',
            confidence: 'Confidence',
            fieldNone: 'Ignore column',
            mapFailed: 'Could not suggest column mapping',
            mapHeadersMissing: 'Could not read CSV headers',
            mapNeedsAddress: 'Map at least one column to destination_address',
            startImport: 'Create orders',
            confirmPickup: 'Confirm pickup',
            skipRow: 'Skip',
            localService: 'Default local service (overridable per row)',
            thirdPartyDefault: 'Partner service default (out of zone)',
            cheapest: 'Cheapest',
            fastest: 'Fastest',
            routingLocal: 'Local',
            routingThirdParty: 'Partner',
            routingInvalid: 'Needs fix',
            row: 'Row',
            address: 'Address',
            zone: 'Zone',
            service: 'Service',
            price: 'Price',
            totalPrice: 'Total',
            summaryTitle: 'Created orders',
            blockingAnomalies: 'Rows with errors are skipped. You can continue with the valid rows.',
            anomaly: {
                missing_address: 'Missing address',
                missing_postal: 'Missing postal code',
                malformed_address: 'Invalid address',
                missing_dimensions: 'Package dimensions required (out of zone)',
                third_party_disabled: 'Partner delivery is not enabled for this merchant',
                unparseable_packages: 'Could not parse packages column',
                outside_canada: 'Address is outside Canada',
            },
            warning: {
                city_inferred: 'City inferred from address',
                postal_inferred: 'Postal code inferred from address',
                quantity_defaulted: 'Quantity defaulted to 1',
                coords_incomplete: 'Latitude and longitude must both be provided',
                coords_invalid: 'Invalid latitude/longitude; address will be geocoded',
            },
            judgment: {
                typesafe_low_confidence: 'Skipped by AI review — address or completeness looks weak',
            },
            columnsTitle: 'Accepted CSV columns',
            exampleHint: 'Optional latitude and longitude skip Google geocoding when both are present.',
            colLatitude: 'Optional destination latitude. If latitude and longitude are both present, Google is not queried to geocode the address.',
            colLongitude: 'Optional destination longitude (negative in Québec, e.g. -73.56). Requires latitude.',
            queued: 'Queued',
            processing: 'Processing',
            completed: 'Completed',
            failed: 'Failed',
            close: 'Close',
            sameDay: 'Flexible (before 21:00)',
            sameDayPlanned: 'Flexible planned',
            fast: 'Punctual (4h)',
            fastPlanned: 'Punctual planned',
            urgent: 'Direct',
            urgentPlanned: 'Direct planned',
            business: 'Business (before 17:00)',
            businessPlanned: 'Business planned',
            splitPickupHint: 'Local and partner pickup windows do not overlap. Confirm each group separately.',
            localPickupGroup: 'Local pickup',
            partnerPickupGroup: 'Partner pickup',
            confirmLocalPickup: 'Confirm local pickup',
            confirmPartnerPickup: 'Confirm partner pickup',
            localPickupConfirmed: 'Local pickup confirmed.',
            partnerPickupConfirmed: 'Partner pickup confirmed.',
        },
        headers: {
            client: 'Client',
            comments: 'Comment',
            completedStops: 'Completed stops',
            date: 'Date',
            delay: 'Delay',
            delivery: 'Delivery',
            driver: 'Driver',
            pickup: 'Pickup',
            hour: 'Hour',
            itinerary: 'Itinerary',
            noDedicatedDriverToMerchant: 'No driver assigned to your business',
            noDriver: 'No driver',
            noDriverAssigned: 'No driver assigned',
            noDriverToSchedule: 'No driver scheduled',
            noOnlineDriver: 'No online driver',
            offlineDrivers: 'Offline drivers',
            onlineDriver: 'Online drivers',
            onlineDrivers: 'Online drivers',
            ordersOrder: 'Order of orders',
            routeNumber: 'Route #',
            scheduleOfTheDay: 'Schedule of the day',
            status: 'Status',
            todaySchedule: 'No driver scheduled today'
        },
        lastInvoice: 'Last invoice',
        loading: 'Loading...',
        map: 'Map',
        myOnlineDrivers: 'My online drivers',
        manageDriversList: 'Manage the driver list',
        nbHoursWorked: 'Hours worked',
        noComments: 'No comments available',
        noItinery: 'No itinerary in progress',
        noOrders: 'No orders in progress',
        order: 'order',
        orders: 'Orders',
        ordersOrder: 'Order of orders',
        pageTitle: 'Dashboard - Merchant - Orders',
        paymentMethod: 'Payment method',
        roadComment: 'Route comment',
        roadScheduled: 'Scheduled time',
        routes: 'Routes',
        stats: 'Statistics',
        stopsCompleted: '{current} / {total} completed',
        title: 'What would you like to do today?',
        totalDeliveryHours: 'Hours worked',
        hoursOnRoute: 'Hours on route',
        driverEarnings: {
            earnings: 'Earnings',
            paidTime: 'Paid time',
            distanceTraveled: 'Distance traveled',
            commissions: 'Commissions',
            dedicatedShifts: 'Dedicated Shifts',
            tips: 'Pre-paid tips',
            guarantee: 'Guarantee',
            bonus: 'Bonus',
            totalEarnings: 'Total earnings',
            weeklyView: 'Weekly statistics',
            weeklyTitle: 'Weekly earnings',
            weekTotal: 'Week total',
            activity: 'Activity',
            online: 'Online',
            busy: 'On route',
            guaranteedHours: 'Guaranteed hours',
            previousWeek: 'Previous week',
            nextWeek: 'Next week',
            backToDriver: 'Back to driver',
            noWeeklyData: 'No earnings for this week',
            today: 'Today',
            pickDate: 'Pick a date',
            previous: 'Previous',
            next: 'Next',
            noEarnings: 'No earnings for this day',
            routeNumber: 'Route #',
            nbStops: 'Nb Stops',
            completedAt: 'Completed at',
            noOrders: 'No orders found',
        },
    },
    planner: {
        title: 'Planner',
        subtitle: 'Review deliveries and scheduled drivers, then generate suggested routes.',
        date: 'Planning date',
        dateEnd: 'Range end',
        multiDayHint: 'Multi-day plan ({days} days) — flexible deliveries go to the best-fit day',
        deliveries: 'Deliveries',
        scheduledDrivers: 'Scheduled drivers',
        deliveryCount: '{count} included delivery(ies)',
        excludedCount: '{count} excluded',
        noDeliveries: 'No deliveries for this date.',
        unknownMerchant: 'Unknown merchant',
        exclusions: 'Deliveries to include',
        deliverySelection: 'Delivery selection',
        includeAll: 'Include all',
        excludeAll: 'Exclude all',
        driverSchedule: 'Driver schedule',
        results: 'Suggested routes',
        copilotSuggestions: 'Copilot suggestions',
        copilotEmpty: 'No Copilot suggestions for this date.',
        copilotLoading: 'Loading suggestions…',
        noDriverYet: 'No driver',
        linkDriver: 'Link a driver',
        createdRoad: 'Route created',
        reserve: 'Reserve',
        fullCapacity: 'Full capacity',
        noScheduledDrivers: 'No scheduled drivers.',
        scheduledWithoutRoute: 'Scheduled without a suggested route',
        routingRules: '{count} applicable routing-guide rule(s)',
        planAction: 'Create dispatch plan',
        loading: 'Loading planning context…',
        optimizing: 'Optimizing…',
        queued: 'Planning queued…',
        unassigned: 'Unassigned ({count})',
        summary: '{shipments} planned delivery(ies) — {routes} suggested route(s)',
        planningDate: 'Plan for {date}',
        planningDateRange: 'Plan from {start} to {end}',
        skippedLocked: '{count} already on a route (skipped)',
        addToRoadCapacity: 'Remaining capacity: {remaining}',
        existingStopsKept: '{count} stop(s) already on the route (kept)',
        alreadyOnRoad: 'Already on a route',
        changeDriver: 'Change driver',
        driverAvailable: 'Available',
        swapWithRoute: 'Swap',
        routeKept: 'Route kept — same stop order.',
        cannotChangeAddToRoad: 'This suggestion adds stops to an existing route, so the driver cannot be changed.',
        assignThisRoute: 'Assign this route',
        alreadyHasRoute: 'Already has a route',
        selectAllSuggestions: 'Select all',
        selectSuggestion: 'Select {title}',
        removeSelection: 'Remove selection ({count})',
        removeConfirmTitle: 'Remove selection',
        removeConfirm: 'Remove {count} route suggestion(s)? This cannot be undone.',
        removeSuccess: '{count} route suggestion(s) removed.',
        removeSuccessWithSkipped: '{count} route suggestion(s) removed. {skipped} already decided.',
        removeNone: 'No suggestions removed. {skipped} already decided.',
        removePartial: '{count} suggestion(s) removed.',
        removeForbidden: 'You do not have permission to remove these suggestions.',
        removeInvalid: 'The selection cannot be removed.',
        removeError: 'Unable to remove the suggestions. Please try again.',
        modes: {
            live: 'Live (online drivers)',
            scheduled: 'Scheduled (shifts)',
        },
        periods: {
            morning: 'Morning',
            afternoon: 'Afternoon',
            evening: 'Evening',
            unspecified: 'Unspecified',
        },
        clusterHeat: 'Volume by cluster',
        qa: {
            title: 'Quality check',
            score: 'Score {score}',
            zigzag: 'Zigzag detected',
            continuous: 'Continuous direction',
            slaOk: 'SLA OK',
            slaRisk: 'SLA at risk',
        },
        errors: {
            load: 'Unable to load deliveries and shifts.',
            noDeliveries: 'No delivery selected.',
            rangeTooLong: 'Planning range cannot exceed {max} days.',
        },
    },
    sameDayPlan: {
        title: 'Driver suggestions',
        menuAction: 'Driver suggestions',
        subtitle: 'Driver-centric route proposals — reassign any delivery before accepting.',
        dragHint: 'Drag a stop between drivers to move that delivery (pickup + drop-off). Reorder stops within a list as usual.',
        dropHere: 'Drop a delivery here',
        summary: '{deliveries} delivery(ies) — {routes} proposed route(s)',
        optimize: 'Optimize',
        optimizing: 'Optimizing…',
        acceptAll: 'Accept routes ({count})',
        confirmAccept: 'Accept {count} proposed route(s)?',
        unassigned: 'Unassigned ({count})',
        newRoute: 'New',
        stops: '{count} stop(s)',
        stop: 'Stop',
        delivery: 'Delivery',
        pickupStop: 'Pickup',
        deliveryStop: 'Drop-off',
        changeDriver: 'Change driver',
        distanceKm: '{km} km',
        durationMin: '{minutes} min',
        errors: {
            load: 'Unable to compute the route plan.',
            noDeliveries: 'No delivery selected.',
            reassign: 'Unable to recompute after changing driver.',
            accept: 'Unable to accept one or more routes.',
            emptyRoute: 'A proposed route is empty.',
        },
    },
    navigation: {
        dashboard: 'Dashboard',
        search: 'Search',
        deliveries: 'Deliveries',
        recurringDeliveries: 'Recurring Deliveries',
        drivers: 'Drivers',
        online: 'Online',
        all: 'All',
        active: 'Active',
        inactive: 'Inactive',
        incidents: 'Incidents',
        routes: 'Routes',
        routesHistory: 'Routes History',
        routingGuide: 'Routing guide',
        planner: 'Planner',
        current: 'Current',
        history: 'History',
        schedule: 'Schedule',
        merchantSchedule: '5@8 Schedule',
        roadSchedules: 'Road Schedules',
        schedulePlanning: 'Schedule planning',
        scheduleDedicatedLive: 'Dedicated service — live',
        logs: 'Logs',
        driverAvailabilities: 'Driver availabilities',
        trackingHistory: 'Tracking History',
        reports: 'Reports',
        ordersHistory: 'Orders history',
        ordersReport: 'Orders Report',
        mapReport: 'Map Report',
        addresses: 'List of saved addresses',
        business: 'Edit business information',
        users: 'Users',
        billing: 'Billing',
        invoices: 'Invoices',
        payments: 'Payments',
        dispatcherReports: 'Reports',
        orders: 'Orders',
        transactions: 'Transactions',
        kpi: 'KPI',
        dailyProfitability: 'Daily profitability',
        volumeEstimate: 'Volume estimate',
        merchants: 'Merchants',
        inactiveMerchants: 'Inactive Merchants',
        invoicing: 'Invoicing',
        merchantInvoices: 'Merchant Invoices',
        driverReceipts: 'Driver Receipts',
        settings: 'Settings',
        support: 'Support',
        downloadApp: 'Download App',
        manage: 'Manage',
        showMap: 'Show Map',
        dedicatedDrivers: 'Dedicated Drivers',
    },
    merchantDetail: {
        recentOrders: 'Last orders',
        recentInvoices: 'Last invoices',
        noOrders: 'No orders',
        noInvoices: 'No invoices',
        copied: 'Copied',
        profileTab: 'Profile',
        currentOrdersTab: 'Current orders',
        viewCurrentOrders: 'View current orders',
        loadOrdersError: 'Unable to load current orders.',
    },
    search: {
        title: 'Global search',
        placeholder: 'Search an order, route, driver, merchant, invoice, tracking...',
        merchantPlaceholder: 'Search an order, address, or invoice...',
        merchantPlaceholderWithFleet: 'Search an order, address, invoice, driver, or route...',
        hint: 'Search by ID, name, address, phone, email or tracking number',
        shortcutHint: 'to search',
        minChars: 'Type at least 2 characters',
        searching: 'Searching...',
        noResults: 'No results for "{{query}}"',
        viewAll: 'View all results',
        errorTimeout: 'Search timed out. Please try again.',
        error: 'An error occurred while searching.',
        groups: {
            orders: 'Orders',
            destinations: 'Addresses',
            routes: 'Routes',
            drivers: 'Drivers',
            merchants: 'Merchants',
            invoices: 'Invoices',
            driver_reports: 'Driver Reports',
        },
        matchedOn: {
            name: 'Name',
            recipient: 'Recipient',
            address: 'Address',
            city: 'City',
            postal_code: 'Postal code',
            phone: 'Phone',
            email: 'Email',
            external_id: 'External ID',
            tracking_number: 'Tracking number',
            merchant: 'Merchant',
            driver: 'Driver',
            order: 'Order',
            id: 'ID',
        },
    },
    destinations: {
        noSavedAddress: 'No saved addresses',
        subcontractorScopeHint: 'Shared subcontractor-level addresses (not tied to a specific merchant).',
        headers: {
            name: 'Name',
            phoneNumber: 'Phone number',
            address: 'Address',
            city: 'City',
            actions: 'Actions'
        },
        actions: {
            addAddress: 'Add address',
            modifyAddress: 'Modify address',
            newAddress: 'New address',
            import: 'Import',
            export: 'Export',
            delete: 'Delete',
            bulkDelete: 'Delete selected'
        },
        deleteConfirm: 'Are you sure you want to delete this address?',
        bulkDeleteConfirm: 'Are you sure you want to delete the {{count}} selected addresses?',
        import: {
            title: 'Import addresses',
            description: 'Import addresses from a CSV file. The address, city and postal_code columns are required. latitude and longitude are optional (automatic geocoding if missing).',
            acceptedColumns: 'Accepted CSV columns',
            columnName: 'Column',
            descriptionColumn: 'Description',
            chooseFile: 'Choose CSV file...',
            importButton: 'Import',
            name: 'Recipient name',
            phone: 'Phone number',
            address: 'Address (required)',
            city: 'City (required)',
            postalCode: 'Postal code (required)',
            latitude: 'Latitude (optional)',
            longitude: 'Longitude (optional)',
            appartment: 'Apartment',
            comment: 'Delivery comment',
            timeToComplete: 'Time on site in minutes (optional, once per visit)'
        },
        timeToComplete: 'Time on site (minutes)',
        timeToCompleteHint: 'Leave empty for the default. Otherwise, minutes spent at this stop, once per visit.',
        export: {
            success: 'Export successful',
            filename: 'addresses.csv'
        },
        importSuccess: 'addresses imported successfully',
        importAddressCityPostalRequired: 'Address, city and postal code are required for each row. Please ensure the postal code column is filled.',
    },
    mapReport: {
        actions: {
            filter: 'Filter'
        },
        emptyState: 'No orders found for this date range.'
    },
    clientPortal: {
        navbar: {
            help: 'Help',
            helpIntro: 'Questions?',
            helpCallLabel: 'Call us at',
            helpEmailLabel: 'or email us at:',
            languageMenu: 'Choose language',
        },
        home: {
            title: 'Customer portal',
            signIn: 'Sign in',
            whatToday: 'What would you like to do today?',
            hiring: 'Hiring',
            becomeDriver: 'Become a driver',
        },
        request: {
            destinationsQuestion: 'How many destinations?',
            singleDestination: 'Single destination',
            multiDestination: 'Multiple destinations',
            recurringQuestion: 'Do you have recurring needs?',
            chooseService: 'Choose a service',
            dedicatedDriver: 'Dedicated driver',
            dedicatedBlurb1: 'Driver dedicated to your business, paid hourly',
            dedicatedBlurb2: '+ more economical if order volume can be delivered in the same time window / region',
            dedicatedBlurb3: 'Requires 24 hours to assign a driver to the shift',
            payPerPiece: 'Pay per delivery',
            payPerBlurb1: 'Volume does not justify a dedicated driver',
            payPerBlurb2: 'Orders must be delivered to different areas',
            payPerBlurb3: 'Pickup and delivery times are flexible',
            howManyParcels: 'How many parcels?',
            singleShipment: 'Single shipment',
            shuttleService: 'Shuttle service',
            transferBetweenStores: 'Transfer between stores',
            etc: 'etc.',
            multipleParcels: 'Multiple parcels',
            pageTitleMultiParcel: 'New service request - Multiple parcels',
            pageTitleOneTime: 'New service request - One-time',
            pageTitleSingleShipment: 'New service request - Single shipment',
            merchantContactTitle: 'Business contact details',
            scheduleTitle: 'Schedule',
            pickupAddressTitle: 'Pickup address',
            destinationTitle: 'Destination',
            next: 'Next',
            resetForm: 'Reset form',
            chooseAddressFromList: 'Please choose an address from the dropdown list',
        },
        tracking: {
            enterTrackingNumber: 'Enter your tracking number',
            enterReferenceNumber: 'Order reference number',
            enterDestinationPostalCode: 'Destination postal code',
            lookupError: 'No order found for this reference and postal code.',
            track: 'Track',
            pageTitleDetail: 'Order tracking',
        },
        register: {
            hubMerchantsTitle: 'Merchants / Shippers',
            hubDriversTitle: 'Drivers',
            signUp: 'Sign up',
            merchantPageTitle: 'Merchant registration',
            driverPageTitle: 'Driver registration',
            driverHeading: 'Driver registration',
            stepAccount: 'Account',
            stepProfile: 'Profile',
            stepConfirmation: 'Confirmation',
            alreadyHaveAccount: 'Already have an account?',
            emergencyContactRequired: 'Please enter an emergency contact',
            emergencyPhoneRequired: 'Please confirm the emergency contact phone number',
            vehicleModelRequired: 'Please select a vehicle model',
            driverLastNameRequired: 'Please enter your last name',
        },
        mfOrder: {
            newRequestTitle: 'New transport request',
            newRequestDocTitle: 'New request',
            pickup: 'Pickup',
            destination: 'Destination',
            save: 'Save',
            noMerchantFound: 'No business found',
            poweredBy: 'Powered by',
        },
    },
    proofOfDelivery: {
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        noPodYet: 'No proof of delivery yet. You can add one.',
        noData: 'No data available.',
        comment: 'Comment / Received by',
        deliveryDateTime: 'Delivery date and time',
        saveError: 'Failed to save proof of delivery.',
        loading: 'Loading...',
        deliveredAt: 'Delivered at',
        receiveBy: 'Received by',
        commentOnly: 'Comment',
        receiveByAndComment: 'Received by / Comment',
        confirmedBoxes: 'Confirmed boxes',
        receivedByPlaceholder: 'Received by',
        signature: 'Signature',
        receptionImage: 'Reception image',
        download: 'Download',
        fetchError: 'Failed to load proof of delivery.',
        invalidDepositedPackageCount: 'The number of boxes must be a whole number between 1 and {{max}}.',
    },
    orderTracking: {
        noOrderFound: 'No order was found',
        deliveryDefault: 'Delivery',
        help: 'Help',
        callMerchant: 'Call the merchant',
        callSupport: 'Call support',
        refreshPage: 'Refresh page',
        mapUnavailable: 'Map unavailable',
        deliveryDate: 'Delivery date',
        viewProofOfDelivery: 'View proof of delivery',
        estimatedDate: 'Estimated delivery date',
        estimatedTime: 'Estimated delivery date and time',
        progressConfirmed: 'Confirmed',
        progressPickedUp: 'Picked up',
        progressEnRoute: 'On the way',
        progressDelivered: 'Delivered',
        yourDriver: 'Your driver',
        contactDriver: 'Contact driver',
        orderCancelled: 'This order was cancelled',
        orderReturnedToMerchant: 'This order was returned to the merchant',
        statusHeading: 'Status',
        orderReference: 'Delivery reference number',
        deliveryAddress: 'Delivery address',
        apartment: 'Apartment',
        comment: 'Comment',
        reviewPrompt: 'How was your experience? Let us know!',
        leaveReview: 'Leave a review',
        poweredBy: 'Powered by',
        proofOfDeliveryTitle: 'Proof of delivery',
        thirdPartyCarrierIntroStart: 'This shipment is handled by ',
        thirdPartyCarrierIntroEnd: '. ',
        thirdPartyCarrierLink: 'Click here',
        thirdPartyCarrierAfterLink: ' to open the carrier\'s tracking page.',
        status: {
            enAttente: 'Being prepared, waiting for a driver',
            assigne: 'Delivery is assigned to a route',
            enDirection: 'Driver is heading to pickup',
            arrive: 'Driver has arrived at the merchant',
            recupereeCarrier: 'Out for delivery with the carrier',
            recuperee: 'Driver has picked up the order',
            enRoute: 'Driver is on the way',
            livre: 'Order delivered!',
            annule: 'Order was cancelled',
            enRetour: 'Return in progress to merchant',
            retour: 'Order was returned to merchant',
            echec: 'Delivery could not be completed',
            attention: 'An issue occurred with the delivery',
            transitCarrier: 'In transit to you',
            transit: 'In transit',
            aConfirmer: 'Order received but not yet ready for pickup',
            transitGeneric: 'In transit',
            waiting: 'Pending',
        },
    },
    procedureDocument: {
        pickupLabel: 'Pickup procedure',
        dropoffLabel: 'Dropoff procedure',
        upload: 'Upload PDF',
        replace: 'Replace PDF',
        remove: 'Remove',
        view: 'View procedure',
        deleteConfirm: 'Remove this procedure?',
        uploadFailed: 'Unable to upload the PDF.',
        deleteFailed: 'Unable to remove the procedure.',
        viewFailed: 'Unable to open the procedure.',
        invalidType: 'Please select a PDF file.',
        sectionTitle: 'Procedures',
        openInNewTab: 'Open in new tab',
        addLink: 'Add link',
        editLink: 'Edit link',
        saveLink: 'Save link',
        linkPlaceholder: 'https://helpdesk.example.com/article/...',
        linkRequired: 'Please enter a URL.',
        invalidLink: 'The URL must start with http:// or https://.',
        linkFailed: 'Unable to save the link.',
    },
    dedicatedLive: {
        title: 'Dedicated service — live',
        date: 'Date',
        merchants: 'merchants',
        online: 'online',
        activeOrders: 'active deliveries',
        allMerchants: 'All merchants',
        refresh: 'Refresh',
        loading: 'Loading…',
        empty: 'No dedicated shifts for this date.',
        loadError: 'Unable to load dedicated live view.',
        backToList: 'Back to list',
        shifts: 'Shifts',
        noShifts: 'No shifts',
        unassigned: 'Unassigned',
        onlineDrivers: 'Online drivers',
        noneOnline: 'No drivers online',
        offlineDrivers: 'offline',
        noOrders: 'No active deliveries',
    },
    merchantSupport: {
        title: 'Support',
        intro: 'Guides, documentation, and a way to reach the OnShip team.',
        guides: 'Interactive guides',
        guidesIntro: 'Pick a topic, then a task. The guide highlights the screen as you go.',
        back: 'Back',
        topics: {
            orders: 'Deliveries',
            fleet: 'Drivers and map',
            settings: 'Settings',
        },
        useCases: {
            createOrder: 'Create a delivery',
            importOrders: 'Import deliveries',
            trackingLink: 'Get the tracking link',
            printLabel: 'Print a label',
            proofOfDelivery: 'Get the proof of delivery',
            findDelivery: 'Find a delivery',
            mapControls: 'Map controls',
            createRoute: 'Create a route',
            editRoute: 'Edit a route',
            assignDriver: 'Assign a driver',
            setDriverOnline: 'Set a driver online',
            search: 'Search',
            drivers: 'Drivers',
            locations: 'Location history',
            addresses: 'Saved addresses',
            billing: 'Billing',
            business: 'Business information',
            integrations: 'Integrations',
            users: 'Users',
            language: 'Language',
            notifications: 'Email preferences',
            password: 'Password',
        },
        copy: {
            createOrderMenuTitle: 'Deliveries',
            createOrderMenu: 'New deliveries start from Deliveries in the menu.',
            createOrderAddTitle: 'Add a delivery',
            createOrderAdd: 'Click Add an order.',
            createOrderFormTitle: 'Delivery form',
            createOrderForm: 'Enter the pickup, the destination and the packages, then send the delivery.',
            importMenuTitle: 'Import',
            importMenu: 'Open the menu beside Add an order, then choose Import.',
            importFileTitle: 'File',
            importFile: 'Upload your file, match the columns, check the preview, then confirm the pickup.',
            trackingRowTitle: 'Open a delivery',
            trackingRow: 'Click a delivery in the list.',
            trackingNeedOrder: 'Create a delivery first. The tracking link is on its details screen.',
            trackingOpenTitle: 'Tracking link',
            trackingOpen: 'Open Tracking link.',
            trackingShareTitle: 'Share',
            trackingShare: 'Copy the link or send it by email.',
            printBulkTitle: 'Print several labels',
            printBulk: 'Select deliveries, then choose the label size.',
            printRowTitle: 'One delivery',
            printRow: 'You can also print from a single delivery. Click one in the list.',
            printNeedOrder: 'When you have a delivery, open it to print its label. You can also select several and use this print menu.',
            printSheetTitle: 'Label',
            printSheet: 'Print the shipping label from the delivery.',
            podMenuTitle: 'Order history',
            podMenu: 'Proof of delivery is in Order history.',
            podActionsTitle: 'Row actions',
            podActions: 'Open the actions menu on a delivered order.',
            podNeedOrder: 'History is empty for now. After a delivery with a captured proof, the row actions menu offers Proof of delivery.',
            podItemTitle: 'Proof of delivery',
            podItem: 'Choose Proof of delivery. It is available when a proof was captured.',
            findDeliverySearchMenuTitle: 'Search',
            findDeliverySearchMenu: 'Open Search in the menu to find a delivery.',
            findDeliverySearchFieldTitle: 'Search field',
            findDeliverySearchField: 'Search by reference number, address, or customer name. Address and name cover the last 12 months.',
            findDeliveryHistoryMenuTitle: 'History',
            findDeliveryHistoryMenu: 'History lists deliveries for a date range.',
            findDeliveryFilterTitle: 'Filter',
            findDeliveryFilter: 'By default, scheduled deliveries run from 6 days before today to 7 days after. Click Filter to change the start and end dates.',
            mapControlsTitle: 'Map controls',
            mapControls: 'These buttons change what the map shows.',
            mapDriversTitle: 'Drivers',
            mapDrivers: 'Show or hide drivers.',
            mapOrdersTitle: 'Orders',
            mapOrders: 'Show or hide orders.',
            mapRoutesTitle: 'Routes',
            mapRoutes: 'Show or hide routes.',
            mapZoomTitle: 'Zoom',
            mapZoom: 'Zoom in or out.',
            mapDrawTitle: 'Draw a zone',
            mapDraw: 'Draw on the map to select the orders inside a zone.',
            routeActionsTitle: 'Select deliveries',
            routeActions: 'Select the deliveries to group, then open the actions menu.',
            routeCreateTitle: 'Create a route',
            routeCreate: 'Choose Create a route to group the selection.',
            editRouteMenuTitle: 'Routes',
            editRouteMenu: 'Routes are managed from Routes in the menu.',
            editRouteRowTitle: 'Choose a route',
            editRouteRow: 'Open the actions menu of the route you want to edit.',
            editRouteNeedRoute: 'Create a route first. You can then edit it from this list.',
            editRouteActionTitle: 'Edit',
            editRouteAction: 'Choose Edit.',
            editRouteEditorTitle: 'Route editor',
            editRouteEditor: 'Reorder the stops and adjust the route, then save.',
            driverOnlineMenuTitle: 'Drivers',
            driverOnlineMenu: 'Online and offline drivers are managed from Drivers.',
            driverOnlineOfflineTitle: 'Offline drivers',
            driverOnlineOffline: 'Open the list of offline drivers.',
            driverOnlineActionTitle: 'Online',
            driverOnlineAction: 'Open the driver menu, then choose Online. The driver can then receive deliveries.',
            driverOnlineNeedDriver: 'Add a driver first, or all your drivers are already online. Online is in the menu of an offline driver.',
            assignActionsTitle: 'Select deliveries',
            assignActions: 'Select the deliveries, then open the actions menu.',
            assignChooseTitle: 'Assign',
            assignChoose: 'Choose Assign to give these deliveries to a driver. You can also assign from a single delivery.',
            searchLinkTitle: 'Search',
            searchLink: 'Search finds orders, addresses, invoices and, when you have drivers, drivers and routes.',
            searchFieldTitle: 'Search field',
            searchField: 'Type at least two characters.',
            driversTitle: 'Drivers',
            drivers: 'Manage the driver accounts for your business.',
            locationsTitle: 'Location history',
            locations: 'Review where your drivers have been.',
            addressesTitle: 'Saved addresses',
            addresses: 'Keep frequent destinations so you can reuse them on an order.',
            billingTitle: 'Billing',
            billing: 'Invoices, payments and your payment method.',
            businessLinkTitle: 'Business',
            businessLink: 'Open your business profile.',
            businessFormTitle: 'Business profile',
            businessForm: 'Update the address, the default delay, notifications and whether a proof of delivery is required.',
            integrationsTitle: 'Integrations',
            integrations: 'Connect a point of sale or another order source.',
            usersTitle: 'Users',
            users: 'Add the people who can use this merchant account.',
            languageTitle: 'Language',
            language: 'Switch the interface between French and English.',
            notificationsTitle: 'Email preferences',
            notifications: 'Choose which emails you receive.',
            passwordLinkTitle: 'Password',
            passwordLink: 'Open the password form.',
            passwordFormTitle: 'New password',
            passwordForm: 'Enter your current password, then the new one.',
        },
        documentation: 'Documentation',
        documentationIntro: 'Help articles and tutorials',
        openDocumentation: 'Link to documentation',
        ticket: 'Support ticket',
        ticketIntro: 'Describe your request. We will reply by email at: {{email}}',
        supportHours: 'Support hours: 9 a.m. to 8 p.m. every day',
        avgResponseTime: 'Average response time: 10 minutes',
        subject: 'Subject',
        message: 'Message',
        send: 'Send',
        ticketSent: 'Your request was sent. We will reply shortly.',
        ticketFailed: 'Unable to send your request. Please try again.',
        contact: 'Contact',
        openChat: 'Open chat',
        tourNext: 'Next',
        tourPrev: 'Back',
        tourDone: 'Done',
    },
};
